import React, { Component } from 'react';
import './clicker-flow-practice-list.scss';
import { Modal, ModalBody, Tooltip, ModalFooter, Button } from "reactstrap";
import { Constants, ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Service from '../../../apis/service-manager';
import Filter from './filter/filter'
import CompletionReport from '../../class-work-V1/completion-report/completion-report'
import HomeworkEvalutionReport from '../../class-work-V1/reports/evaluation-report/evaluation-report'
// import StudentLevelReport from '../reports/student-level-report/student-level-report'
// import HomeworkProgressionReport from '../reports/level-progression-report/level-progression-report'
// import StudentDetailReport from '../reports/student-level-report/student-detail/student-detail'
import EloReport from '../reports/elo-report/elo-report'
import HomeworkForClickerPracticeApi from '../../../apis/homework-for-clicker-practice';
import HomeworkApi from '../../../apis/homework';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import WronglyAnswered from '../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
// import ArchiveModal from '../../common/archive/archive'
// import ReminderModel from '../reminder/reminder'
import EloDetail from './elo-detail/elo-detail'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import Loading from '../../common/loading/loading'
import SessionCache from '../../routes/session-cache';
// import NotificationModel from '../../tests-v3/test-list/notification/notification'
import SuccessComponent from '../../tests-v3/test-list/success/success'
import AllQuestions from '../../tests-v3/reports/all-questions/all-questions';
import moment from 'moment';
import NewHomework from '../new-homework/new-homework'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import QuestionList from './questions-list/questions-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SchoolApi from '../../../apis/school';
import RecommandationReport from '../../class-work-V1/recommandation-report/recommandation-report';
// import ActiveHomeworkModal from '../../common/active-homework/active-homework';
import StandardClassWorkExperience from '../clicker-practice-experience/standard-classwork-experience';
import StandardClassworkExperienceOffline from '../../../offline/clicker-practice-experience/standard-classwork-experience';
import BarChart from '../bar-chart/bar-chart';
import Path from '../../routes/routes-path';
import { Link, Redirect } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import CommonApi from '../../../apis/common';
import LayoutShared from '../../common/layout-shared/layout-shared';
import CommonUtils from '../../../utility/common-utilities';
import IndexedDBHelperV2 from "../../../offline/apis/indexDBManager-v2";
import ChapterEloAssessmentReport from './chapter-elo-assessment-report/chapter-elo-assessment-report';
import ClickerAssessmentEndScreen from '../assessment-end-screen/assessment-end-screen';
import StartAssessment from '../start-assessment/start-assessment';
import ClickerTesting from './clicker-testing/clicker-testing';
import Urls from '../../../apis/url';
import BaslineVsFinishLineReport from '../reports/baseline-vs-finishline-report/baseline-vs-finishline-report';
import StudentNameList from './student-name-list/student-name-list';
import ClassPerformanceReport from './class-performance-report/class-performance-report';
import ExcelJS from "exceljs";
import OverallClassPerformanceReport from './overall-class-performance-report/overall-class-performance-report';
import SchoolworkOverallClassPerformanceReport from './schoolwork-class-performance-report/overall-class-performance-report';
import AssignmentDeletionComponent from '../../common/assignment-deletion-modal/archive';
import Leaderboard from '../question/leaderboard/leaderboard';
import ClickerRevisionExperience from '../revision-experience/revision-experience';
import JigyasaAssessment from '../../clicker-assessment-experience/jigyasa-assessment';
import QustionsListForAssessment from '../../clicker-assessment/reports/questions-list/all-questions'
import TestResultReport from '../../clicker-assessment/reports/test-results/test-results'
import EloReportForAssessment from '../../clicker-assessment/reports/elo-report/elo-report'
import RecommandationReportForAssessment from '../../clicker-assessment/reports/recommandation-report/recommandation-report'
import ClassPerformanceReportForAssessment from '../../clicker-assessment/test-list/class-performance-report/class-performance-report'
// import AsyncStore from "../../../../shared-storage/async-store";
let { Parser } = require('json2csv');

const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);



class HomeworkList extends Component {

    state = {
        homeworkList: [],
        topWrongPercentage: 0,
        contentIds: [],
        eloReport: [],
        copiedId: null,
        leaderboardData: [],
        tabs: [
            { title: "My Activities", value: "ACTIVE" },
            { title: "Active", value: "ACTIVE" },
            { title: "Completed", value: "COMPLETED" },
            // { title: "Draft", value: "DRAFT" },
            // { title: "Past Due Date", value: "PAST_DUE_DATE" },
            // { title: "Archived", value: "ARCHIVED" }
        ],
        activeTabIndex: 0,
        showTimer: false,
        showStartPracticeScreen: false,
        selectedFilters: [
            // { type: "Class", value: "7th" }
        ],
        showBackButton: this.props.showBackButton ? this.props.showBackButton : false,
        isDraft: false,
        isFinishLine: false,
        isLoading: true,
        meta: { totalPages: 1, page: 1 },
        levels: [
            {
                type: "NOVICE",
                title: "Novice",
                subTitle: '<50%',
                students: [
                ]
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                subTitle: '50% - 80%',
                students: []
            },
            {
                type: "ADVANCE",
                title: "Advance",
                subTitle: '>80%',
                students: []
            }
        ],
        usersList: [],
        content: [],
        showTestClickerScreen: false,
        showUsersList: false,
    }
    limit = 10
    filter = { status: "ACTIVE", }
    currentPage = 1;
    // pageLimit = 10
    teacherHomeworkActivityStatusHash = {}

    accessRights = SessionCache.getAllowedModule()

    skillList = [
        {
            type: "KNOWLEDGE",
            title: "KNOWLEDGE - Ability to remember formulas",
            image: ImageConstants.KNOWLEDGE,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CALCULATION",
            title: "CALCULATION - Ability to Calculate",
            image: ImageConstants.CALCULATION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MODELING",
            title: "MODELING - Ability to get Logic & form equation",
            image: ImageConstants.MODELING,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "COMPREHENSION",
            title: "COMPREHENSION - Ability to Understand the Language",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        }]

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension"]

    constructor(props) {
        super(props)
        if (this.props.filter) {
            this.filter = {
                status: "ACTIVE",
                board: this.props.filter?.board || "",
                class: this.props.filter?.class || "",
                chapter: this.props.filter?.chapterKey || ""
            }
        }
        this.layoutShared = LayoutShared.getLayout()
        this.userInfo = SessionCache.getUser()
        // console.log(this.layoutShared)
    }

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension"]

    componentDidMount() {

        // console.log('component did mount called')

        // console.log(this.props.location.pathname)

        if (this.props.location?.pathname === '/school/conceptcards') {
            this.setState({ type: Constants.CLICKER_CONCEPT_CARD }, () => {
                this.getTeacherHomeworkActivities()
            })

        } else {
            this.getTeacherHomeworkActivities()
        }

        if (this.props.delegate?.props?.location?.state?.homeworkFilterPayload?.from === "LEARNING_RESOURCES") {

            this.setState({ showBackButton: true })
        }


        // this.getHomeworkList(this.filter)

        document.addEventListener('mousedown', this.handleClickEvent, false);

        if (this.props.delegate?.props?.location?.state?.homeworkAssignPayload?.from === "LEARNING_RESOURCES") {
            this.onClickNewHomeWork()
        }

        if (this.props.delegate?.props?.location?.state?.homeworkAssignPayload?.from === "RECOMMANDATION_REPORT") {
            this.onClickNewHomeWork()
        }

        if (this.props.delegate?.props?.location?.state?.from === 'NEW_HOMEWORK_CREATION') {
            console.log(this.props.delegate?.props?.location?.state)
        }

        if (this.props.type != 'ADAPTIVE_CLASSWORK') {
            let tabs = this.state.tabs
            // tabs.push({ title: "Draft", value: "DRAFT" })
            this.setState({ tabs })
        }

        if (window.electron) {
            this.resetZoom()
        }


        if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
            this.layoutShared.state.homeworkItem._id &&
            this.layoutShared.state.homeworkItem.teacherHomeworkActivityStatus != 'COMPLETED' &&
            !this.layoutShared.state.homeworkItem.isEndPractice) {
            setTimeout(() => {
                this.onClickCard(this.layoutShared.state.homeworkItem)
            }, 500)

        }

        if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
            this.layoutShared.state.homeworkItem._id &&
            this.layoutShared.state.homeworkItem.teacherHomeworkActivityStatus != 'COMPLETED' &&
            this.layoutShared.state.homeworkItem.isEndPractice) {
            this.setState({ isLoading: true }, () => {
                setTimeout(() => {
                    this.onClickEndPractice(this.layoutShared.state.homeworkItem)
                }, 1000)
            })
        }

        // if (CommonUtils.isOnline() && this.layoutShared.state.homeworkItem) {
        //     this.updateItem(this.layoutShared.state.homeworkItem._id, this.layoutShared.state.homeworkItem, "SYNC")
        // }

    }

    resetZoom() {
        window.electron.ipcRenderer.send('reset-zoom', ['ping'])
    }


    getTeacherHomeworkActivities() {
        let payload = {}
        // this.toggleLayoutBar()
        payload.type = this.state.type === Constants.CLICKER_CONCEPT_CARD ? [Constants.CLICKER_CONCEPT_CARD, Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT] : ["CLICKER_PRACTICE_STANDARD"]

        // console.log(CommonUtils.isOnline())

        this.setState({ isLoading: true })

        if (CommonUtils.isOnline()) {
            HomeworkApi.getTeacherHomeworkActivities(payload).then(res => {
                // console.log(res)
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'CLICKER_PRACTICE_STANDARD').then(localRes => {
                    console.log(localRes)

                    let homeworkListHash = {}

                    localRes.forEach(item => homeworkListHash[item._id] = item)
                    if (res.contents.length > 0) {
                        let completedHomework = [], notCompletedHomework = []
                        res.contents.forEach(item => {
                            if (item.status === 'COMPLETED') {
                                completedHomework.push(item)
                            } else {
                                notCompletedHomework.push(item)
                            }

                            if (homeworkListHash[item._id]) {
                                console.log(homeworkListHash[item._id].status)
                                item.status = item.status === 'COMPLETED' ? 'COMPLETED' : homeworkListHash[item._id].status
                                item.pendingSync = homeworkListHash[item._id].pendingSync ? homeworkListHash[item._id].pendingSync : false
                                item.isPresentInThisSystem = true
                            }
                            this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                        })
                        this.setState({ content: res.contents, completedHomework, notCompletedHomework, isReload: true }, () => {
                            this.getHomeworkList(this.filter)
                        })
                    } else {
                        this.setState({ isLoading: false })
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        } else {
            let userInfo = SessionCache.getUser()

            if (userInfo && userInfo.schoolInfo && userInfo.schoolInfo.schoolCode) {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'schoolId', userInfo.schoolInfo.schoolCode).then(res => {
                    console.log(res)

                    res = res.sort((a, b) => new Date(b.countingwellCreatedTimestamp
                    ) - new Date(a.countingwellCreatedTimestamp
                    ))

                    // console.log(res)

                    res.forEach(item => {
                        item.isPresentInThisSystem = true
                        this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                    })

                    res = res.filter(item => item.type === 'CLICKER_PRACTICE_STANDARD')

                    this.setState({ content: res }, () => {
                        this.getHomeworkList(this.filter)
                    })
                }).catch(err => {
                    console.log(err)
                })
            } else {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'CLICKER_PRACTICE_STANDARD').then(res => {
                    console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

                    res.forEach(item => {
                        item.isPresentInThisSystem = true
                        this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                    })

                    this.setState({ content: res }, () => {
                        this.getHomeworkList(this.filter)
                    })
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ userListIndex: -1 })
        }
    }


    getHomeworkList(payload = {}) {

        if (!payload.page) payload.page = 1
        if (!payload.limit) payload.limit = this.limit
        console.log(this.props.type)

        // if (this.props.type === 'STANDARD_CLASSWORK') {
        //     payload.type = 'STANDARD,STANDARD_CLASSWORK'
        // } else {
        //     payload.type = 'ADAPTIVE,ADAPTIVE_CLASSWORK'
        // }

        payload.type = this.state.type === Constants.CLICKER_CONCEPT_CARD ? Constants.CLICKER_CONCEPT_CARD : "CLICKER_PRACTICE_STANDARD"
        this.currentPage = payload.page

        if (this.currentPage === 1) this.startIndex = 1

        this.setState({ isLoading: true, meta: {}, isDraft: false })

        if (CommonUtils.isOnline()) {
            HomeworkApi.getHomework(payload)
                .then(response => {
                    console.log(response.response)
                    this.buildHomeworkList(response.response)
                    this.setState({ meta: response.meta, totalpages: response.meta.count, isLoading: false })
                }).catch(err => {
                    this.setState({ isLoading: false })
                })
        } else {
            let userInfo = SessionCache.getUser()

            if (userInfo && userInfo.schoolInfo && userInfo.schoolInfo.schoolCode) {
                dbHelper.getAllFromIndex(Constants.HOMEWORK_STORE, 'schoolId', userInfo.schoolInfo.schoolCode).then(res => {
                    console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDateTimestamp) - new Date(a.createdDateTimestamp))

                    res = res.filter(item => item.type === 'CLICKER_PRACTICE_STANDARD')

                    this.buildHomeworkList(res)


                    this.setState({ isLoading: false })
                }).catch(err => {
                    console.log(err)
                })
            } else {
                dbHelper.getAllFromIndex(Constants.HOMEWORK_STORE, 'type', 'CLICKER_PRACTICE_STANDARD').then(res => {
                    // console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
                    this.buildHomeworkList(res)

                    this.setState({ isLoading: false })
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }

    buildHomeworkList(homeworks) {
        let homeworkGroup = {}, individualHomework = []
        let homeworkList = []
        for (let i = 0; i < homeworks.length; i++) {
            let homework = homeworks[i]

            let titles = ''

            if (homework?.chapter?.chapterList) {
                titles = homework?.chapter?.chapterList.map(ch => ch.title).join(', ');
            }

            let obj = {
                _id: homework._id,
                createdDateTimestamp: CommonUtils.isOnline() ? homework.countingwellCreatedTimestamp : homework.createdDateTimestamp,
                createdDate: new Date(homework.createdDateTimestamp || homework.createdDate).toLocaleDateString("en-IN"),
                dueDate: new Date(homework.endDate).toLocaleDateString("en-IN"),
                masterDataId: homework.masterDataId,
                chapter: homework?.chapter?.title ? homework?.chapter?.title : titles,
                chapterKey: homework?.chapter?.key ? homework?.chapter?.key : homework?.chapter?.chapterList,
                concepts: homework?.chapter?.concept,
                section: homework.section,
                sectionId: homework.sectionId,
                class: homework.class,
                board: homework.board,
                completed: homework.completed,
                notCompleted: homework.notCompleted,
                inProgress: homework.inProgress,
                status: homework.status,
                conceptBuild: homework?.chapter?.conceptBuild,
                notificationCount: homework?.notificationCount || 0,
                lastNotificationSentDate: homework?.lastNotificationSentDate,
                approximateQuestions: homework?.approximateQuestions,
                approximateTime: homework?.approximateTime,
                category: homework?.category,
                users: homework?.users || [],
                basePath: homework.basePath,
                type: homework.type,
                cwPracticeNumber: homework.cwPracticeNumber ? homework.cwPracticeNumber : 0,
                showTimer: homework.showTimer,
                showLeaderboard: homework.showLeaderboard,
                leaderboardLimit: homework.leaderboardLimit,
                selectedSetId: homework.selectedSetId ? homework.selectedSetId : '',
                baseLineHomeworkId: homework.baseLineHomeworkId ? homework.baseLineHomeworkId : null,
                createdBy: homework.createdBy,
                selectedSetTitle: homework.selectedSetTitle,
                schoolAssessmentId: homework.schoolAssessmentId ? homework.schoolAssessmentId : '',
                autoNext: homework.autoNext ? homework.autoNext : false,
                revisionType: homework.revisionType ? homework.revisionType : '',
                chapters: homework.chapters ? homework.chapters : ''
            }


            if (homework.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
                obj.time = homework.duration ? homework.duration : homework.time ? homework.time : 0
                obj.questions = homework.questionIds ? homework.questionIds.length : homework.questions ? homework.questions : 0
                obj.chapters = homework?.chapters
            }


            if (this.userInfo.subjectId === Constants.SCIENCE_SUBJECTID) {
                obj.subSubjectId = homework.subSubjectId
                obj.subSubjectName = homework.subSubjectName
            }

            if (this.teacherHomeworkActivityStatusHash[homework._id]) {
                obj.teacherHomeworkActivityStatus = this.teacherHomeworkActivityStatusHash[homework._id].status
                obj.teacherHomeworkActivityId = this.teacherHomeworkActivityStatusHash[homework._id]._id
                obj.isDownloaded = this.teacherHomeworkActivityStatusHash[homework._id].isDownloaded
                obj.pendingSync = this.teacherHomeworkActivityStatusHash[homework._id].pendingSync
                obj.clickerSet = this.teacherHomeworkActivityStatusHash[homework._id].clickerSet
                obj.isStudentBulkReportGenerationDone = this.teacherHomeworkActivityStatusHash[homework._id].isStudentBulkReportGenerationDone ? true : false
                obj.countingwellLastUpdateTimestamp = this.teacherHomeworkActivityStatusHash[homework._id].countingwellLastUpdateTimestamp
                obj.isPresentInThisSystem = this.teacherHomeworkActivityStatusHash[homework._id].isPresentInThisSystem ? true : false
                obj.resumeQuestionNumber = this.teacherHomeworkActivityStatusHash[homework._id].resumeQuestionNumber ? this.teacherHomeworkActivityStatusHash[homework._id].resumeQuestionNumber : 0
            }

            if (this.state.type === Constants.CLICKER_CONCEPT_CARD) {
                obj.conceptCardPdf = homework?.chapter?.chapterList ? homework?.chapter?.chapterList[0].conceptCardPdf : ''
            }

            if (homework.assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS') {
                obj.assessmentQuestionType = homework.assessmentQuestionType
                obj.contentsHash = homework.contentsHash
            }

            if (homework.groupId) {
                if (homeworkGroup[homework.groupId]) {
                    homeworkGroup[homework.groupId].push(obj)
                } else {
                    homeworkGroup[homework.groupId] = [obj]
                }
            } else {
                individualHomework.push(obj)
            }
        }

        let groupedHomework = Object.values(homeworkGroup)

        homeworkList.push(...groupedHomework, ...individualHomework)

        this.setState({ homeworkList })

    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                console.log(school)
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name, showWarningPopup: true })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }


    expand = (item, index) => {
        // let homeworkList = this.state.homeworkList
        // homeworkList[index].expand = !homeworkList[index].expand
        console.log(item)
        this.setState({ showMoreInfo: true, selectedHomeworkMore: item })
    }

    hideMoreInfoModal = () => {
        this.setState({ showMoreInfo: false })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index, selectedItemIndex: null, selectedItemGroupIndex: null })
        let tab = this.state.tabs[index]
        this.filter.status = tab.value
        this.filter.page = 1
        this.getHomeworkList(this.filter)
    }

    hideReport = () => {
        // console.log(this.state.selectedHomework)
        this.setState({ showReport: false, selectedReportType: '' }, () => {
            this.scrollIntoViewForCurrentItem(this.state.selectedHomework._id)
        })
    }

    hideEloReport = (value) => {
        this.hideReport()
        this.setState({ showReport: false, selectedReportType: '' }, () => {
            this.getTeacherHomeworkActivities()
        })

        if (value) {
            this.toggleLayoutBar()
        }

    }

    toggleLayoutBar() {
        // console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        if (window.electron) {
            window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
        }

        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    onClickBack = () => {

        if (Constants.ELECTRON_BUILD) {
            this.props.history.push(Path.DASHBOARD)
        }

        if (this.props.delegate?.props?.location?.state?.homeworkFilterPayload.from === "LEARNING_RESOURCES") {
            this.props.delegate.props.history.push({ pathname: Path.LEARNING_RESOURCES, state: { ...this.props.delegate.props.location.state.homeworkFilterPayload, from: 'NEW_HOMEWORK_CREATION' } })
        } else {
            this.props.back && this.props.back()
        }
    }

    onClickNewHomeWork = (item, index, isDraft, isFinishLine) => {

        if (isDraft || isFinishLine) {
            console.log(item)
            let concepts = item.concepts
            let conceptKeysList = [], eloIdsList = []
            concepts.forEach((concept, index) => {
                conceptKeysList.push({ value: concept.key, order: index + 1 })

                if (concept.elos && concept.elos.length) {
                    concept.elos.forEach(elo => {
                        eloIdsList.push({ value: elo.id, conceptValue: concept.key })
                    })
                }
            })
            item.conceptKeysList = conceptKeysList
            item.eloIdsList = eloIdsList
            // console.log(item)
            this.getClasses()
            this.setState({ showNewHomework: true, selectedHomework: item, selectedItemIndex: index, isDraft, isFinishLine, assessmentQuestionType: item.assessmentQuestionType, contentsHash: item.contentsHash })
        } else {
            this.getClasses()
            this.setState({ showNewHomework: true })
        }

    }

    hideNewHomework = (value) => {

        console.log('hide homework Called')

        this.setState({ activeTabIndex: 0 })
        if (value) {
            this.filter = { status: "ACTIVE" }
            this.getTeacherHomeworkActivities()
            this.showToaster('info', "Classroom Practice Created successfully")
        }
        this.setState({ showNewHomework: false, showWarningPopup: false })
    }


    showReport = (type, item, index, grpIndex, fromScreen) => {
        this.setState({
            showStandardClassworkExperience: false, showReport: true, selectedReportType: type, selectedHomework: item, selectedItemIndex: index,
            selectedItemGroupIndex: grpIndex, fromScreen
        })
    }

    downloadCompletionExcelReport(type, item, index, grpIndex) {

        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit
        // payload.type = this.props.match.params.type
        payload.type = type


        // if (this.props.match.params.homeworkId) {
        //     payload.homeworkId = this.props.match.params.homeworkId
        // }

        if (item && item._id) {
            payload.homeworkId = item._id
        }

        HomeworkApi.getHomeworkCompletionReport(payload)
            .then(response => {
                console.log("response", response)
                this.setState({
                    completedStudents: response.completedStudents,
                    inProgressStudents: response.inProgressStudents,
                    notCompletedStudents: response.notCompletedStudents, isLoading: false
                }, () => {
                    this.onClickCompletionReportExport()
                })
            }).catch(err => {
            })

    }


    // onClickCompletionReportExport = () => {

    //     if (this.state.exporting) return

    //     this.setState({ exporting: true })
    //     console.log("Export")


    //     if (this.state.completedStudents && this.state.completedStudents.length) {

    //         let homeworkCompletedStudentArray = this.state.completedStudents

    //         console.log(homeworkCompletedStudentArray)

    //         let csvBuild = []
    //         for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
    //             let item = homeworkCompletedStudentArray[i]

    //             let obj = {
    //             }
    //             if (item["name"]) {

    //                 if (item['name']) {
    //                     obj['Student Name'] = item['name']
    //                 }

    //                 // if (item['conceptName']) {
    //                 //     obj['Understood'] = "Understood"
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Understood'] = 'Not Understood'
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Attempted'] = 'Not Attempted'
    //                 // }
    //             }
    //             csvBuild.push(obj)

    //         }
    //         let json2csvParser = new Parser();
    //         let csv = json2csvParser.parse(csvBuild);

    //         console.log(csv);

    //         let hiddenElement = document.createElement('a');
    //         hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    //         hiddenElement.target = '_blank';
    //         hiddenElement.download = 'Completion_report_' + (new Date).toISOString() + '.csv';
    //         hiddenElement.click();
    //         this.setState({ exporting: false })
    //     } else {
    //         this.setState({ exporting: false })
    //     }
    // }

    onClickCompletionReportExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Completion Report");

        // Header
        sheet.mergeCells("A1:C1");
        sheet.getCell("A1").value = "Completion Report";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };


        // Table header
        const headerRow = sheet.addRow(["Completed", "Inprogress", "Not Completed"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });

        // Find max length between both arrays
        const maxLength = Math.max(this.state.completedStudents.length, this.state.inProgressStudents.length, this.state.notCompletedStudents.length);

        // Fill rows with student names
        for (let i = 0; i < maxLength; i++) {
            sheet.addRow([
                (this.state.completedStudents[i] && this.state.completedStudents[i].name) || "", // Completed name if exists
                (this.state.inProgressStudents[i] && this.state.inProgressStudents[i].name) || "", // Not completed name if exists
                (this.state.notCompletedStudents[i] && this.state.notCompletedStudents[i].name) || ""
            ]);
        }

        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `completion_report_${this.state.selectedHomework.chapter.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }

    downloadEvaluationExcelReport(type, item, index, grpIndex) {
        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (item && item._id) {
            payload.homeworkId = item._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkEvaluationReport(payload)
            .then(response => {
                console.log(response)
                let levels = this.state.levels
                let noviceStudents = response?.noviceStudents || []
                let proficientStudents = response?.proficientStudents || []
                let advancedStudents = response?.advancedStudents || []

                levels[0].students = noviceStudents
                levels[1].students = proficientStudents
                levels[2].students = advancedStudents

                this.setState(
                    {
                        noviceStudents: response.noviceStudents,
                        proficientStudents: response.proficientStudents,
                        advancedStudents: response.advancedStudents,
                        notCompletedStudents: response.notCompletedStudents,
                        isLoading: false,
                        levels
                    }, () => {
                        this.onClickEvaluationReportExport()
                    })

            }).catch(err => {
            })
    }

    onClickEvaluationReportExport() {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        if (this.state.levels && this.state.levels.length) {

            let homeworkCompletedStudentArray = this.state.levels

            console.log(homeworkCompletedStudentArray)

            let csvBuild = []

            // let reportTitle = {'Title' : "Learning Gap Report"}

            // csvBuild.push(reportTitle)

            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let item = homeworkCompletedStudentArray[i]

                let obj = {
                }
                if (item["type"]) {

                    if (item['type']) {
                        obj['Type'] = item['type']
                    }

                    // if (item['conceptName']) {
                    //     obj['Understood'] = "Understood"
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Understood'] = 'Not Understood'
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Attempted'] = 'Not Attempted'
                    // }

                    csvBuild.push(obj)


                    console.log(item.students)
                    let studentObject = {}
                    if (item.students && item.students.length > 0) {
                        for (let j = 0; j < item.students.length; j++) {
                            console.log(item.students[j])
                            let student = item.students[j]
                            studentObject[`Type`] = student.name
                            studentObject[`Mark Scored`] = student.marks
                            studentObject[`Total Marks`] = student.totalMark
                            csvBuild.push(studentObject)
                            studentObject = {}
                        }
                    } else {
                        studentObject['Type'] = 'No Students in this Type'
                        csvBuild.push(studentObject)
                        studentObject = {}
                    }
                }
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'Assessment_Result_Report' + (new Date).toISOString() + '.csv';
            hiddenElement.click();

            this.setState({ exporting: false })

        } else {
            this.setState({ exporting: false })
        }


    }

    downloadLearningGapExcelReport(type, item, index, grpIndex) {
        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (item && item._id) {
            payload.homeworkId = item._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                this.setState({ skillWiseReport: result, eloReport: response.conceptBaseReport, totalUsers: response.totalUsers, isLoading: false }, () => {
                    this.onClickExportLearningGapExcelReport()
                })

            }).catch(err => {

                this.setState({ isLoading: false })
            })
    }




    onClickExportLearningGapExcelReport = () => {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")

        let eloList = this.state.eloReport

        if (eloList && eloList.length > 0) {

            let homeworkCompletedStudentArray = eloList

            // console.log(homeworkCompletedStudentArray)

            let csvBuild = []
            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let item = homeworkCompletedStudentArray[i]

                let obj = {
                }
                if (item["conceptName"]) {

                    if (item['conceptName']) {
                        obj['Concept Name'] = item['conceptName']
                    }

                    // if (item['conceptName']) {
                    //     obj['Understood'] = "Understood"
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Understood'] = 'Not Understood'
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Attempted'] = 'Not Attempted'
                    // }

                    csvBuild.push(obj)

                    let eloObject = {}

                    let elo = item
                    if (elo.skill == "modelling") elo.skill = "modeling"
                    let skills = elo.skill
                    for (let index = 0; index < this.orderedSkills.length; index++) {
                        let key = this.orderedSkills[index]
                        let skillDetails = skills[key]

                        if (!skillDetails) continue

                        if (skillDetails && skillDetails.length) {
                            // arr.push(
                            //     <tr className="mt-4">
                            //         <td className="skill-title pl-5" colSpan="4">
                            //             <span>
                            //                 <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-4">{key.toUpperCase()}</b>
                            //             </span>
                            //         </td>
                            //     </tr>
                            // )


                            for (let i = 0; i < skillDetails.length; i++) {
                                let item = skillDetails[i]
                                let notAttempted = this.state.totalUsers - ((item.incorrect || 0) + (item.correct || 0))
                                eloObject['Concept Name'] = item.title
                                eloObject['Understood'] = item.correct
                                eloObject['Not Understood'] = item.incorrect
                                eloObject['Not Attempted'] = notAttempted
                                csvBuild.push(eloObject)
                                eloObject = {}
                            }
                        }

                    }
                }
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'learning_gap_report_' + (new Date).toISOString() + '.csv';
            hiddenElement.click();

            this.setState({ exporting: false })

        } else {
            this.setState({ exporting: false })
        }
    }




    downloadClassPerformanceExcelReport = (type, item, index, grpIndex) => {
        // this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        console.log(item)

        let payload = {
            homeworkId: item._id,
            classText: item.class,
            board: item.board,
            type: item.type,
            sectionId: item.sectionId,
            section: item.section,
            masterDataId: item.masterDataId,
            duration: item.approximateTime,
            chapterKey: item.chapterKey
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)

            this.onClickExportClassPerformanceExcelReport(res, item)
            this.setState({ isLoading: false })

        }).catch(err => {
            console.log(err)
        })

    }


    onClickExportClassPerformanceExcelReport = async (classPerformanceData, selectedItem) => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Student Report");

        // Header
        sheet.mergeCells("A1:D1");
        sheet.getCell("A1").value = "Summary";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };



        // Info section
        // sheet.addRow([]);
        sheet.addRow(["Class", `${selectedItem.class.split(' ')[1]}${selectedItem.section}`]);
        sheet.addRow(["Date", this.getDate(selectedItem.createdDateTimestamp, true)]);
        sheet.addRow(["Chapter", selectedItem.chapter]);
        sheet.addRow(["Concepts", classPerformanceData.conceptTitleList.join(',')]);

        // sheet.addRow([]);


        // sheet.mergeCells("A6:D6");
        // sheet.getCell("A6").value = "Summary";
        // sheet.getCell("A6").font = { bold: true, size: 14 };
        // sheet.getCell("A6").alignment = { horizontal: "center" };
        // sheet.getCell("A6").fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "4AB7E7" }, // Blue background
        // };

        sheet.addRow(["Total Questions", `${selectedItem.approximateQuestions}`]);
        sheet.addRow(["Total Students", classPerformanceData.summary.totalStudents]);
        sheet.addRow(["Total Attempted", classPerformanceData.summary.totalCompletedStudents]);
        sheet.addRow(["% Accuracy", classPerformanceData.summary.accuracyPercentage + '%']);
        sheet.addRow([]);


        sheet.mergeCells("A11:E11");
        sheet.getCell("A11").value = "Student Performance Details";
        sheet.getCell("A11").font = { bold: true, size: 14 };
        sheet.getCell("A11").alignment = { horizontal: "center" };
        sheet.getCell("A11").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };

        // Table header
        const headerRow = sheet.addRow(["Rank", "Name", "# Questions Attempted", "# Questions Correct", "% Score"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.studentDetails.forEach((item, index) => {
            if (index === classPerformanceData.studentDetails.length - 1) {
                let lastRow = sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, `${item.scorePercentage}%`]);
                lastRow.font = { bold: true };
            } else {
                sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, `${item.scorePercentage}%`]);
            }
        });

        sheet.addRow([]);

        let secondHeaderRow = sheet.addRow(["Not Attempted Students"]);
        secondHeaderRow.font = { bold: true, size: 12 };
        // secondHeaderRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        secondHeaderRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.notAttemptedStudentNameList.forEach((item, index) => {
            sheet.addRow([item]);
        });


        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `student_performance_report_${selectedItem.chapter.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    scrollIntoViewForCurrentItem(id) {
        const element = document.getElementById(id);
        // console.log(id, element)
        element.scrollIntoView({ behavior: "instant", block: 'center' })

    }




    getTabs = () => {
        return (<div>
            {this.state.tabs.map((tab, index) => (
                <div key={'tab' + index} className={`tab mr-3 ${this.state.activeTabIndex == index ? 'tab-active' : ''}`} onClick={() => this.onClickTab(index)}>
                    <div className='tab-center'>
                        <span>{tab.title}</span>
                    </div>
                </div>
            ))}
        </div>)
    }

    handleDateEvent = (event, picker, item, index) => {
        this.dueDate = picker.startDate ? (new Date(new Date(picker.startDate).setHours(23, 59, 59, 999)).toISOString()) : ''

        let payload = { homeworkId: item._id, dueDate: this.dueDate, }
        HomeworkApi.updateHomework(payload)
            .then(response => {
                this.getHomeworkList(this.filter)
            }).catch(err => {
            })
    }

    hideWrongAnswersReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    hideStudentLevelReport = () => {
        this.setState({ showStudentLevelReport: false })
    }

    hideReminderModal = () => {
        this.setState({ showReminderModal: false })
    }

    onOkArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onCloseArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onOkDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }

    onCloseDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }

    onOkClickerAssignModal = () => {
        this.setState({ showClickerAssignModal: false })
    }

    onCloseClickerAssignModal = () => {
        this.setState({ showClickerAssignModal: false })
    }




    onOkActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    onCloseActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    onCLickNotitification(item, type) {
        this.setState({ notificationType: type, selectedItem: item, showNotification: true })
    }

    hideNotification = () => {
        this.setState({ showNotification: false })
    }

    onSentNotification = () => {
        this.hideNotification()

    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 5000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    renderReminderModal = () => {
        // return (
        //     <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideReminderModal} size={'lg'}>
        //         <ModalBody >
        //             <ReminderModel message={this.state.reminderMessage} notCompleted={this.state.notCompleted} homeworkId={this.state.reminderHomeworkId} notificationCount={this.state.notificationCount} notificationDate={this.state.notificationDate} back={this.hideReminderModal} />
        //         </ModalBody>
        //     </Modal>
        // )
    }

    renderNotificationIcons(item) {
        return (
            <div className="notification-icons">
                <span className="pt-2 mr-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.EMAIL)} onClick={() => this.onCLickNotitification(item, "EMAIL")} />
                </span>
                <span className="pt-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.WHATSAPP)} onClick={() => this.onCLickNotitification(item, "WHATSAPP")} />
                </span>
            </div>
        )
    }

    onChangeType = (type) => {
        this.setState({ notificationType: type })
    }

    showSuccessModal = (item) => {
        console.log(item)
        let selectedSection = {}
        item.sectionId.forEach(sectionId =>
            selectedSection[sectionId] = item.section[sectionId]
        )

        item.section = selectedSection

        this.setState({ showSuccess: true, selectedItem: item })
    }

    onInviteMoreStudent = () => {
        this.setState({ showSuccess: false, notificationType: "WHATSAPP", showNotification: true })
    }

    closeSuccess = () => {
        this.setState({ showSuccess: false })
    }

    showOverallLeaderboard(item, index) {
        console.log(item)
        this.setState({ selectedItem: item })
        this.getQuestionLeaderBoard(item)
    }

    hideQuestionLeaderboard() {
        this.setState({ showQuestionLeaderBoard: false })
    }

    getQuestionLeaderBoard(item) {
        let payload = {
            homeworkId: item._id,
            status: "COMPLETED"
        }

        if (CommonUtils.isOnline()) {
            HomeworkForClickerPracticeApi.getHomeworkPracticeQuestionLeaderBoard(payload).then(res => {
                console.log(res)
                this.setState({ leaderboardData: res.leaderboardBuild }, () => {

                    this.setState({ showQuestionLeaderBoard: true })

                })
            }).catch(err => {
                console.log(err)
            })
        } else if (!CommonUtils.isOnline()) {

            let homeworkId = item._id

            dbHelper.getAllFromIndex(Constants.CLICKER_ASSESSMENT_LEADERBOARD, 'homeworkId', homeworkId).then(leaderboardBuild => {

                leaderboardBuild.sort((a, b) => a.rank - b.rank)

                this.setState({ leaderboardData: leaderboardBuild }, () => {
                    // if (value) {
                    this.setState({ showQuestionLeaderBoard: true })
                    // }
                })

            }).catch(err => {
                console.log(err)
            })
        }
    }


    // renderNotificationModal = () => {
    //     return (
    //         <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNotification} size={'lg'}>
    //             <ModalBody >

    //                 <div className="row">
    //                     <div className="col text-right">
    //                         <img alt="" className="close-icon cursor-pointer" onClick={this.hideNotification} src={getImageSource(ImageConstants.CROSS)} />
    //                     </div>
    //                 </div>

    //                 <div className="header-text text-center pt-4">
    //                     <span>SHARE THE INVITE WITH STUDENTS</span>
    //                 </div>
    //                 <NotificationModel type={this.state.notificationType} from="HOMEWORK" assessment={this.state.selectedItem} onChangeType={this.onChangeType} onOk={this.onSentNotification} />
    //             </ModalBody>
    //         </Modal>
    //     )
    // }


    getButtonTitle = (status) => {
        if (status == 'ASSIGNED')
            return "Start"

        if (status == 'COMPLETED')
            return "Completed"

        if (status == 'IN_PROGRESS')
            return "Resume"
    }

    handleCopy = (id) => {
        navigator.clipboard.writeText(id)
            .then(() => {

                this.setState({ copiedId: id });
                ReactTooltip.hide();

                setTimeout(() => {
                    this.setState({ copiedId: null });
                }, 2000);


            })
            .catch(err => console.error("Copy failed:", err));
    };

    getHomeworkCard = (item, index, groupIndex) => {

        return (
            <div className='homework-card'>
                <div className=''>
                    <div className='row'>
                        <div className='col d-flex align-items-center'>
                            <div>
                                <img className='chapter-icon' src={getImageSource(ImageConstants.CHAPTER_ICN)} />
                            </div>
                            <div className='pl-2'>
                                {
                                    this.userInfo.subjectId === Constants.SCIENCE_SUBJECTID ?
                                        <div className='body-sub-title pt-1'>
                                            <strong>{`${item.subSubjectName}, `}</strong>
                                            <strong>{item.chapter}</strong></div>

                                        :
                                        <div className='body-sub-title pt-1'><strong>{item.chapter}</strong></div>
                                }
                                {/* <div className='body-sub-title pt-1'><strong>{item.chapter}</strong></div> */}

                                {
                                    CommonUtils.isOnline() && item.isDownloaded && this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ?
                                        <></>
                                        :
                                        <div className='body-title'>{item.board}, {item.class} {item.section} {`${item.teacherHomeworkActivityStatus === 'IN_PROGRESS' ? `, Clicker ${item.selectedSetTitle}` : ""}`}</div>
                                }


                                {/* <div className='body-title'>{item.board}, {item.class} {item.section} {`${item.teacherHomeworkActivityStatus === 'IN_PROGRESS' ? `` : ""}`}</div> */}
                            </div>
                        </div>
                    </div>
                    {
                        this.state.type === Constants.CLICKER_CONCEPT_CARD ?
                            <div className='body-title' style={{ fontWeight: 'bold' }}>{item.revisionType === Constants.ONLY_REVISION ? 'Revision' :
                                item.type === Constants.CLICKER_CONCEPT_CARD ? 'Revision With Practice' :
                                    item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ? 'Revision With Assessment' : 'Revision'}</div>
                            :
                            <></>
                    }

                    {
                        CommonUtils.isOnline() && item.type != Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                            <div className='row pt-3'>
                                <div className='col'>
                                    <div className='body-title'>Concepts
                                        <span className='cursor-pointer pl-2 more-text' onClick={() => this.expand(item, index)}>{item.expand ? 'Less' : 'More >>'}</span>
                                    </div>
                                    <div className='body-sub-title'><strong>{item.concepts && item.concepts.length && item.concepts[0] && item.concepts[0].title ? item.concepts[0].title : ""}</strong></div>
                                </div>
                            </div>
                            :
                            <></>
                    }


                    <div className='created-date'>
                        Created On : {this.getDate(item.createdDateTimestamp, true)}
                    </div>
                    {
                        CommonUtils.isOnline() && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                            <div className='completed-date'>
                                Completed On : {this.getDate(item.countingwellLastUpdateTimestamp, true)}
                            </div>
                            :
                            <></>
                    }

                    <div className='question-wrapper mt-4 mb-4 d-flex align-items-center '>
                        <div className='d-flex align-items-center border-right-for-question pr-2'>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.QUESTION_MARK)} />
                            <span className='pl-2 question-count'>{item.approximateQuestions}</span>
                        </div>
                        <div className='d-flex align-items-center pl-2'>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.CLOCK_IMAGE)} />
                            <span className='pl-2 question-count'>{item.approximateTime}</span>
                        </div>
                    </div>
                    {
                        item.type != Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ? <div className='leader-board-wrapper mb-3 d-flex align-items-center' onMouseEnter={ReactTooltip.rebuild}>
                            <div className='show-timer-wrapper d-flex align-items-center'>
                                <img className="status-image" src={getImageSource(item.showTimer ? ImageConstants.CORRECT : ImageConstants.WRONG)} />
                                <img className="clock-image ml-1" src={getImageSource(ImageConstants.CLOCK_IMAGE)} />
                            </div>
                            <div className={`show-timer-wrapper d-flex align-items-center ml-2
                        ${item.showLeaderboard ? 'cursor-pointer' : ''}`}
                                onClick={() => this.showOverallLeaderboard(item, index)}
                                data-tip={item.showLeaderboard ? "View Leaderboard" : ''}
                            >
                                <img className="status-image"
                                    src={getImageSource(item.showLeaderboard ? ImageConstants.CORRECT : ImageConstants.WRONG)} />
                                <img className="clock-image ml-1" src={getImageSource(ImageConstants.LEADER_BOARD_BLOCK)} />
                                {
                                    item.showLeaderboard ? <span className='leader-board-text'>{item.leaderboardLimit == "5" ? 'Top 5' : item.leaderboardLimit === "10" ? 'Top 10' : item.leaderboardLimit === "ALL" ? 'ALL' : ''}</span> : <></>
                                }
                            </div>
                        </div>
                            :
                            <></>
                    }


                    {
                        item.schoolAssessmentId ?
                            <div className='school-assessmentid-text-wrapper position-relative'>
                                <span className='school-assessmentid-text cursor-pointer'
                                    data-tip={'Copy'}
                                    // data-for={`copyTip-${item.schoolAssessmentId}`}
                                    onClick={() => this.handleCopy(item.schoolAssessmentId)}>{item.schoolAssessmentId}</span>
                                <img className='copy-icon-size'
                                    data-tip={"Copy"}
                                    onClick={() => this.handleCopy(item.schoolAssessmentId)}
                                    src={getImageSource(ImageConstants.COPY_ICON)} />
                                {this.state.copiedId === item.schoolAssessmentId && (
                                    <div className="copied-tooltip">
                                        Copied!
                                    </div>
                                )}
                            </div>
                            :
                            <></>
                    }

                </div>

            </div>
        )

    }

    renderStatus = (item, index, grpIndex) => {
        return (<div onMouseEnter={ReactTooltip.rebuild}>
            <div className='completed' >
                <div className='completed-text d-flex justify-content-center'>
                    <div className='cursor-pointer' data-tip={"Present"} onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }} >
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.CORRECT)} />
                        </span>
                        <span className="ml-2">
                            {
                                item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                                    `${item.completed ? item.completed : 0}`
                                    :
                                    `${item.completed && item.completed.length ? item.completed.length : 0}`
                            }

                        </span>
                    </div>
                </div>
            </div>

            <div className='in-progress mt-3'>
                <div className='in-progress-text d-flex justify-content-center'>
                    <div className='cursor-pointer' onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }} >
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.IN_PROGRESS_ICON)} />
                        </span>
                        <span className="ml-2">
                            {
                                item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                                    `${item.inProgress ? item.inProgress : 0}`
                                    :
                                    `${item.inProgress && item.inProgress.length ? item.inProgress.length : 0}`
                            }

                        </span>
                    </div>
                </div>
            </div>

            <div className='not-completed mt-3'>
                <div className='not-completed-text d-flex justify-content-center'>
                    <div className='cursor-pointer' data-tip={"Not Present"} onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }}>
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.WRONG)} /></span>
                        <span className="ml-2">
                            {
                                item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                                    `${item.notCompleted ? item.notCompleted : 0}`
                                    :
                                    `${item.notCompleted && item.notCompleted.length ? item.notCompleted.length : 0}`
                            }

                        </span>
                    </div>
                </div>
            </div>
        </div>)
    }

    onCLickStudentLevelReport(item) {
        this.setState({ showStudentLevelReport: true, selectedHomework: item })
    }


    onClickDownloadPdf = (type, item, index) => {

        this.setState({ selectedReportType: type, selectedItem: item, selectedIndex: index, isPdfLoading: true })

        if (type === 'MOST_WRONG_REPORT') {
            this.getHomeworkWrongAnswer(item, type)
        }

        if (type === "RECOMMANDATION_REPORT") {
            this.getHomeworkWrongAnswer(item, type)
        }

        if (type === 'CLASS_PERFORMANCE_REPORT') {
            this.getClassPerformanceReport(item, type)
        }

        if (type === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT') {
            this.getSchoolworkOverallClassPerformanceReport(item, type)
        }


    }

    getSchoolworkOverallClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey,
            chapterTitle: selectedItem.chapter
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getSchoolworkOverallClassPerformanceReport(payload).then(res => {
            // console.log(res)
            this.setState({ isPdfLoading: false })

            this.downloadPDF(res.link, "Class_Performance_Report")

        }).catch(err => {
            console.log(err)
        })
    }

    getClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)
            // this.setState({ ...res, isLoading: false })
            this.setState({ isPdfLoading: false })
            this.downloadPDF(res.link, 'Students_Performance')

        }).catch(err => {
            console.log(err)
        })
    }

    getEloReport(selectedItem, type) {
        let payload = {}
        if (selectedItem) {
            payload.homeworkId = selectedItem._id
        }


        payload.type = 'CLICKER_PRACTICE_STANDARD'


        // this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                console.log(response)

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                let conceptWiseReport = response.conceptBaseReport

                let conceptWiseTopFiveNotClearedElo = []

                for (let i = 0; i < conceptWiseReport.length; i++) {
                    let concept = conceptWiseReport[i]
                    let allSkills = {}
                    let eloLimit = 0

                    for (let j = 0; j < localSkillList.length; j++) {
                        let skill = localSkillList[j]
                        let detail = concept.skill[skill.type.toLowerCase()]
                        if (!detail) continue

                        let notClearedEloList = []

                        for (let k = 0; k < detail.length; k++) {
                            let elo = detail[k]
                            if (elo.incorrect) {
                                if (eloLimit === 5) continue
                                eloLimit += 1
                                notClearedEloList.push(elo)
                            }
                        }

                        if (!allSkills[skill.type.toLowerCase()]) {
                            allSkills[skill.type.toLowerCase()] = [...notClearedEloList]
                        } else {
                            allSkills[skill.type.toLowerCase()].push(notClearedEloList)
                        }

                    }
                    conceptWiseTopFiveNotClearedElo.push({ conceptName: concept.conceptName, skill: allSkills })

                }


                this.setState({
                    skillWiseReport: result,
                    eloReport: response.topFiveNotClearedEloAcrossConcept,
                    totalUsers: response.totalUsers, isLoading: false
                }, () => {
                    // console.log('callback called')
                    setTimeout(() => {
                        this.generatePdf(response.topFiveNotClearedEloAcrossConcept, selectedItem)
                    }, 1000)

                })

            }).catch(err => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    generatePdf(conceptWiseTopFiveNotClearedElo, selectedItem) {
        console.log(conceptWiseTopFiveNotClearedElo)

        let notClearedEloIds = [], eloNotClearedStudentPercentageHashByEloId = {}

        conceptWiseTopFiveNotClearedElo.forEach(elo => {
            // if (elo.skill == "modelling") elo.skill = "modeling"
            // let skills = elo.skill
            // for (let index = 0; index < this.orderedSkills.length; index++) {
            //     let key = this.orderedSkills[index]
            //     let skillDetails = skills[key]
            //     if (!skillDetails) continue
            //     if (skillDetails && skillDetails.length) {
            //         skillDetails.map(item => {
            notClearedEloIds.push(elo.eloId)
            eloNotClearedStudentPercentageHashByEloId[elo.eloId] = `${this.calculatePercentage(elo.incorrect, this.state.totalUsers) || 0}%`



            //         })
            //     }
            // }
        })

        //console.log(!this.state.contentIds, !notClearedEloIds.length, !this.state.contentIds.length)


        let conceptNames = []
        selectedItem.concepts.forEach(concept => conceptNames.push(concept.title))

        if (!this.state.contentIds.length && !notClearedEloIds.length) {
            console.log('return')
            return;
        }

        let payload = {
            contentIds: this.state.contentIds,
            class: selectedItem.class,
            section: selectedItem.section ? selectedItem.section : "",
            chapterTitle: selectedItem.chapter,
            conceptNames: conceptNames,
            notClearedEloIds,
            topWrongPercentage: this.state.topWrongPercentage,
            eloNotClearedStudentPercentageHashByEloId
        }

        // console.log(payload)

        SchoolApi.generatePdf(payload).then(response => {
            // console.log(response)
            this.setState({ isPdfLoading: false })
            this.downloadPDF(response.data.webLink, "Remedial_Report")
        }).catch(err => {
            console.log(err)
        })

    }

    getHomeworkWrongAnswer(selectedItem, selectedReportType) {
        let payload = {}
        if (selectedItem) {
            payload.homeworkId = selectedItem._id
            payload.type = selectedItem.type
            payload.chapterTitle = selectedItem.chapter
            payload.isPdfGeneration = true
        }

        HomeworkApi.getHomeworkWrongAnswersReport(payload)
            .then(response => {

                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                console.log(result)
                //let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }

                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers
                        result[i].questionCount = questionsArray1.length

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }



                }

                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });


                // console.log('wrong hash', wrongAnswersHash)
                // console.log('unique', unique)



                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => {
                    filterHash[ele] = ele
                })

                let topQuestions = []

                unique.forEach(item => {
                    topQuestions.push(...item.allQuestionsArray)
                })

                let topFiveWrongAnsweredQuestions = topQuestions.slice(0, 5)

                // console.log('top', unique)

                let contentIds = []

                topFiveWrongAnsweredQuestions.forEach(question => contentIds.push(question._id.toString()))

                let topWrongPercentage = unique && unique.length ? unique[0].percentage : 0

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash, topFiveWrongAnsweredQuestions,
                    contentIds,
                    topWrongPercentage,

                })

                if (selectedReportType === 'MOST_WRONG_REPORT') {
                    this.setState({ isPdfLoading: false })
                    this.downloadPDF(response.link, "Most_Wrong_Questions")
                } else {
                    this.getEloReport(selectedItem, selectedReportType)
                }

            }).catch(err => {
                console.log(err)
            })
    }

    downloadPDF(pdfLink, title) {
        const link = document.createElement("a");
        link.href = pdfLink
        // link.target = "_blank";
        link.download = `${title}.pdf`; // name for downloaded file
        link.click();
        this.setState({ selectedReportType: "", selectedItem: '', selectedIndex: "" })
    }



    getReportList = (item, index, grpIndex) => {
        // console.log(".....", item)
        return (
            <div onMouseEnter={ReactTooltip.rebuild}>
                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>

                        <div className='report-wrapper' onClick={() => { this.showReport("COMPLETION_REPORT", item, index) }}>
                            <img className='report-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON)} />
                            <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadCompletionExcelReport("COMPLETION_REPORT", item, index)}>
                                <img data-tip={"Export to Excel"} className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                            </div>
                            :
                            <></>
                    }


                </div>

                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("HOMEWORK_EVALUATION_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            {/* <span className={`${item.completed ? "blue" : ""}`}>{`${item.type === 'STANDARD' ? 'Homework' : 'Classwork'} Evaluation Report`}</span> */}
                            <span className={`${item.completed ? "blue" : ""}`}>{`Evaluation Report`}</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadEvaluationExcelReport("HOMEWORK_EVALUATION_REPORT", item, index)}>
                                <img data-tip={"Export to Excel"} className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                            </div>
                            :
                            <></>
                    }
                </div>

                <div className='row'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("MOST_WRONG_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                            <span className={`${item.completed ? "blue" : ""}`}>Most Wrong Questions</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index && this.state.selectedReportType === 'MOST_WRONG_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("MOST_WRONG_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }

                            </div>
                            :
                            <></>
                    }
                </div>

                <div className='row'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("ALL_QUESTIONS_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.ALL_QUESTIONS)} />
                            <span className={`${item.completed ? "blue" : ""}`}>All Questions</span>
                        </div>
                    </div>
                </div>

                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("ELO_LEVEL_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                            <span className={`${item.completed ? "blue" : ""}`}>Learning Gap Report</span>
                        </div>
                    </div>

                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper cursor-pointer d-flex align-items-center'
                                onClick={() => this.downloadLearningGapExcelReport("ELO_LEVEL_REPORT", item, index)}>
                                <img data-tip={"Export to Excel"} className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />

                            </div>
                            :
                            <></>
                    }


                </div>

                <div className='row'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("RECOMMANDATION_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                            <span className={`${item.completed ? "blue" : ""}`}>Remedial Report</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'RECOMMANDATION_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("RECOMMANDATION_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }


                            </div>
                            :
                            <></>
                    }

                </div>

                {/* <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("STANDARD_COMPETENCY_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${item.completed ? "blue" : ""}`}>{`Standard Vs Competency Report`}</span>
                        </div>
                    </div>
                </div> */}
                <div className='row flex-nowrap align-items-center'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("CLASS_PERFORMANCE_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${item.completed ? "blue" : ""}`}>{`Students Performance Report`}</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper'
                            >
                                <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} data-tip={"Export to Excel"}
                                    onClick={() => this.downloadClassPerformanceExcelReport("CLASS_PERFORMANCE_REPORT", item, index)} />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("CLASS_PERFORMANCE_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }


                            </div>
                            :
                            <></>
                    }
                </div>
                <div className='row flex-nowrap align-items-center'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${item.completed ? "blue" : ""}`}>{`Class Performance Report`}</span>
                        </div>
                    </div>
                    {
                        item.completed && item.completed.length ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }

                            </div>
                            :
                            <></>
                    }
                </div>
                {
                    item.baseLineHomeworkId ?
                        <div className='row flex-nowrap'>
                            <div className='col-7 px-0'>
                                <div className='report-wrapper' onClick={() => this.showReport("BASELINE_FINISHLINE_REPORT", item, index)}>
                                    <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                    <span className={`${item.completed ? "blue" : ""}`}>{`Base Line Vs Finish Line Report`}</span>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                }
            </div>
        )


    }

    showDownloadReport = (item, reportType) => {
        this.setState({
            isDownloading: true,
            selectedItem: item
        }, _ => {
            this.downloadReport(item, reportType)
        })
    }

    downloadReport(item, reportType) {
        const payload = {
            type: this.props.type,
            reportType
        }
        if (item) {
            payload.id = item._id
        }

        HomeworkApi.downloadHomeworkReport(payload)
            .then(response => {
                if (response.url) {
                    window.open(response.url)
                }
                this.setState({ isDownloading: false })
            }).catch(err => {
                this.setState({ isDownloading: false })
                this.showToaster('info', `${err?.response?.data?.message || "Something went wrong"} `)
            })
    }

    getReminderAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_REMINDER]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_REMINDER]
        }
    }

    getArchivedAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_ARCHIVE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_ARCHIVE]
        }
    }

    getActivateHomeworkAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_ACTIVE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_ACTIVE]
        }
    }


    onClickReminderModal(item) {
        let concept = item.concepts?.map(i => i.title) || []
        let [d, m, y] = item.dueDate.split("/")

        if (m.length == 1) {
            m = `0${m}`
        }
        if (d.length == 1) {
            d = `0${d}`
        }
        let dateString = `${y}-${m}-${d}`
        let date = moment(dateString).format("Do MMM")
        let message = `${item.type === 'STANDARD' || item.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} assigned to you from chapter ${item?.chapter || ""}  & concepts ${concept.join(",")} is still pending. Please complete it soon before due date i.e ${date}.`
        let notificationCount = item.notificationCount
        let notificationDate = item.lastNotificationSentDate
        this.setState({
            reminderHomeworkId: item._id,
            reminderMessage: message,
            showReminderModal: true,
            notificationCount,
            notificationDate,
            notCompleted: item?.notCompleted?.length
        })
    }

    getEloDetails(item) {
        console.log(item)
        let concepts = [], elos = []
        if (item.chapters && item.chapters.length) {
            item.chapters.forEach(chapter => {
                chapter.concept.forEach(element => {
                    concepts.push(element.key)
                    element.elos.forEach(item => {
                        elos.push(item.id)
                    })

                });
            })

        } else {
            item.concepts.forEach(element => {
                concepts.push(element.key)
                element.elos.forEach(item => {
                    elos.push(item.id)
                })
            });
        }


        let payload = {
            class: item?.class,
            board: item?.board,
            section: item?.section,
            chapter: item?.chapter,
            concepts: concepts.join(","),
            elos: elos.join(","),
            showTimer: item.showTimer,
            homeworkType: item.type
        }

        if (item.baseLineHomeworkId) {
            payload.baseLineHomeworkId = item.baseLineHomeworkId
        }

        if (!payload.class || !payload.board || !payload.chapter) return

        if (item.assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS') {
            payload.assessmentQuestionType = item.assessmentQuestionType
            payload.contentsHash = Object.keys(item.contentsHash)
        }

        HomeworkApi.getHomeworkEloDetailsForClickerPractice(payload)
            .then(response => {
                this.setState({
                    questionCount: response.questionCount,
                    contents: response.content,
                    // approximateTime: response.questionCount, //ask by ravi
                    approximateTime: response.approximateTime, //ask by ravi
                    questionLoading: false,
                    showQuestionList: true,
                    showTimer: item.showTimer
                })
            }).catch(err => {
            })
    }

    onClickQuestionList(item, index, groupIndex) {
        this.setState({
            selectedQuestionList: item,
            contents: [],
            questionLoadingIndex: index,
            questionLoadingGroupIndex: groupIndex,
            questionLoading: true,
            selectedItem: item
        })

        if (item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
            this.setState({ showQuestionList: true, questionLoading: false })
        } else {
            this.getEloDetails(item)
        }


    }

    hideQuestionList = () => {
        this.setState({ showQuestionList: false })
    }

    showQuestionList = () => {

        if (this.state.selectedItem.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
            return (
                <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                    <ModalBody >
                        <QustionsListForAssessment selectedItem={this.state.selectedItem} delegate={this} close={this.hideQuestionList} />
                    </ModalBody>
                </Modal>
            )
        }



        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionList back={this.hideQuestionList}
                        contents={this.state.contents}
                        questionCount={this.state.questionCount}
                        approximateTime={this.state.approximateTime}
                        showTimer={this.state.showTimer}
                    />
                </ModalBody>
            </Modal>
        )
    }




    getActions = (item, index, groupIndex) => {

        if (!groupIndex) groupIndex = 0

        return (
            <div className="text-right">
                {
                    this.getArchivedAction()
                        ? <>
                            <img alt="" className='action-icon cursor-pointer' id={`rchived-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.ARCHIVE)} onClick={() => this.setState({ showArchiveModal: true, selectedHomework: item })} />
                            <Tooltip className={`${this.state.tooltipOpenIndex === index && this.state.tooltipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={`rchived-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ tooltipOpen: !this.state.tooltipOpen, tooltipOpenIndex: index, tooltipGroupIndex: groupIndex }) }}>
                                Archive
                            </Tooltip>
                        </>
                        : ""
                }
                <span className="pl-4">
                    {
                        this.getReminderAction() ?
                            <>
                                <img alt="" className='action-icon cursor-pointer' id={`reminder-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.REMAINDER)} onClick={() => this.onClickReminderModal(item)} />
                                <Tooltip className={`${this.state.reminderToolTipIndex === index && this.state.reminderToolTipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.reminderTooltipOpen} autohide={false} target={`reminder-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ reminderTooltipOpen: !this.state.reminderTooltipOpen, reminderToolTipIndex: index, reminderToolTipGroupIndex: groupIndex }) }}>
                                    Reminder
                                </Tooltip>
                            </>
                            : ""
                    }
                </span>
            </div>
        )

    }

    getActivateHomework = (item) => {

        return (
            <div className='text-right' >

                {
                    this.getActivateHomeworkAction() ?
                        <span className='cursor-pointer' onClick={() => this.setState({ showActiveConfirmationModal: true, selectedHomework: item })}>Mark As Active</span>
                        : <></>
                }


            </div>
        )

    }


    categoryColor(category) {
        if (category === "ADVANCED") return "bg-lite-blue"
        if (category === "PROFICIENT") return "bg-orange"

        return "bg-purble"
    }

    getCategoryText(category) {

        if (category === "ADVANCED") return "Advanced"
        if (category === "PROFICIENT") return "Proficient"

        return "Novice"
    }

    onClickUserList(index, groupIndex, item) {
        console.log(item)
        this.setState({ userListIndex: index, userListGroupIndex: groupIndex, selectedItem: item, showUsersList: true })
    }



    onHideUserList() {
        this.setState({ userList: [], userListIndex: "", userListGroupIndex: "", showUsersList: false })

    }

    getAllQuestionsReportPdf(item, index) {


        this.setState({ allQuestionsReportIndex: index })

        let payload = {
            isPdfGeneration: true,
            chapterTitle: item.chapter
        }
        payload.homeworkId = item._id

        this.setState({ allQuestionsReportLoading: true })

        HomeworkApi.getHomeworkAllQuetionsReport(payload)
            .then(response => {
                // console.log(response)
                // this.setState({ questions: response.questions || [], basePath: response.basePath })
                this.setState({ allQuestionsReportLoading: false })
                this.downloadPDF(response.link, "All_Questions_Report")
            }).catch(err => {
            })
    }

    showRevisionFlow(item, index) {

        if (!item.conceptCardPdf) {
            alert('No Revision Found')
        }

        let teacherHomeworkActivity = this.teacherHomeworkActivityStatusHash[item._id]

        console.log(teacherHomeworkActivity)

        if (teacherHomeworkActivity.status === 'COMPLETED') return
        if (!teacherHomeworkActivity.clickerSet.length) {
            alert('No Clicker Set Found');
            return;
        }

        if (teacherHomeworkActivity.status === 'ASSIGNED') {
            this.setState({
                showStartPracticeScreen: true,
                selectedItem: item,
                selectedIndex: index,
                // usersList: response.clickerUserList,
                // showStartAssessment: false,
                params: {
                    homeworkId: teacherHomeworkActivity.homeworkId,
                    nodeId: '',
                    nodes: '',
                    title: item.chapter ? item.chapter : '',
                    concepts: '',
                    categoryThemeId: 1,
                    conceptsCovered: '',
                    homework: item,
                    typeOfSchoolwork: "REVISION_FLOW",
                    chapterImageUrl: item.chapterImageUrl ? item.chapterImageUrl : '',
                    status: teacherHomeworkActivity.status,
                    clickerSet: teacherHomeworkActivity.clickerSet,
                    conceptCardPdf: item.conceptCardPdf
                }
            })
        }
    }

    hideRevisionFlow() {
        this.setState({ showRevisionFlow: false, isLoading: true }, () => {
            let item = this.state.selectedItem

            if (this.state.selectedItem.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
                console.log(item)

                let teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item._id]

                if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
                    this.layoutShared.state.homeworkItem.homeworkId &&
                    this.layoutShared.state.homeworkItem.status != 'COMPLETED') {
                    teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item.homeworkId]
                }


                console.log(teacherHomeworkItem)

                if (item.autoNext) {
                    teacherHomeworkItem.autoNext = item.autoNext
                }

                if (item.selectedSetId) {
                    teacherHomeworkItem.selectedSetId = item.selectedSetId
                    teacherHomeworkItem.selectedSetTitle = item.selectedSetTitle
                }

                if (item.teacherHomeworkActivityStatus !== 'COMPLETED') {
                    this.setState({ showAssessmentFlow: true, teacherHomeworkItem, isLoading: false })
                }
            } else if (this.state.selectedItem.revisionType === Constants.ONLY_REVISION) {
                this.setState({ isLoading: false })
                this.toggleLayoutBar()
                this.showToaster('info', "Revison Completed Successfully")
                console.log(this.state.selectedItem, '.........')
            } else {
                this.setState({ isLoading: false })
                this.onClickCard(this.state.selectedItem)
            }
        })
    }

    renderUserList(item) {

        if (item?.users?.length) {
            item.users = item?.users.sort((a, b) => Number(a.rollNumber) - Number(b.rollNumber));
        }



        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.onHideUserList()} src={getImageSource(ImageConstants.WRONG)} />
                    </div>
                </div>
                <div className='student-list-header'>
                    Students List
                </div>

                {
                    item?.users?.length ? item.users.map((user, index) =>
                        <div className='px-4 py-2 row align-items-center '>
                            {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {user.image ? <img className="" alt="img" src={`${item.basePath}${user.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div> */}
                            <div className='student-name'>{user.rollNumber}.</div>
                            <div className='student-name ml-1'>
                                {user.name}
                            </div>
                        </div>
                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    renderTableRow(item, index) {

        const isOnline = CommonUtils.isOnline()

        return (
            <div onMouseEnter={ReactTooltip.rebuild} id={item._id} key={item._id} className={`tr-divider mb-4 mt-5 row pr-0 ${index === this.state.selectedItemIndex ? "tr-bg-color" : ''}`}>
                <div className='col-4 pt-2'>
                    {this.getHomeworkCard(item)}
                </div>
                {
                    item.status === 'DRAFT' ?
                        <>
                            <div className={`col-2 pt-3 ${isOnline ? "" : "pb-3"}`}>
                                {
                                    CommonUtils.isOnline() ?
                                        <div className="" >
                                            {
                                                this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                    :
                                                    <img alt="" className="hambargur-icon cursor-pointer" src={getImageSource(ImageConstants.HANBARGUR_NEW)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                                            }
                                        </div>
                                        :
                                        <></>
                                }

                                <div className='button-wrapper cursor-pointer mb-3 mt-4' style={{ background: '#21b8c7' }} onClick={() => this.onClickNewHomeWork(item, index, true)}>
                                    <div className='start-button'>Assign Practice</div>
                                </div>
                            </div>


                        </>

                        :
                        <>
                            <div className={`col-2 pt-3 ${isOnline ? "" : "pb-3"}`}>
                                {
                                    CommonUtils.isOnline() ?
                                        <div className="d-flex align-items-center" >
                                            <div>
                                                {
                                                    this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                                                        <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                        :
                                                        <img alt="" className="hambargur-icon cursor-pointer" data-tip={'Questions List'} src={getImageSource(ImageConstants.HANBARGUR_NEW)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                                                }
                                            </div>

                                            {
                                                <div className='pl-1 ml-4'>
                                                    <img alt="" data-tip={'Students List'} className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, null, item)} />
                                                    {/* <div className="pl-4">
                                                        {
                                                            this.state.userListIndex === index ? this.renderUserList(item) : ""
                                                        }
                                                    </div> */}
                                                </div>
                                            }
                                            {
                                                item.completed && item.completed.length ?
                                                    <>
                                                        {
                                                            this.state.allQuestionsReportLoading && this.state.allQuestionsReportIndex === index ?
                                                                <FontAwesomeIcon className='ml-4' size="2x" icon={faSpinner} spin />
                                                                :
                                                                <img data-tip={"Download All Questions Report"} className='ml-4 review-answers-icon mt-1 cursor-pointer' onClick={() => this.getAllQuestionsReportPdf(item, index, 0)} src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                                                        }
                                                    </>
                                                    :
                                                    <></>
                                            }
                                        </div>
                                        :
                                        <></>
                                }

                                {
                                    !CommonUtils.isOnline() ?
                                        <div>
                                            {
                                                <div className='pl-1 ml-2'>
                                                    <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, null, item)} />
                                                    {/* <div className="pl-4">
                                                        {
                                                            this.state.userListIndex === index ? this.renderUserList(item) : ""
                                                        }
                                                    </div> */}
                                                </div>
                                            }
                                        </div>
                                        :
                                        <></>
                                }





                                {
                                    Constants.ELECTRON_BUILD ?
                                        item.isDownloaded && item.isPresentInThisSystem ?
                                            <div className='button-wrapper cursor-pointer mb-3 mt-4' style={{ background: '#21b8c7' }} onClick={() => this.onClickTestClicker(item, index)}>
                                                <div className='start-button'>Test Clickers</div>
                                            </div>
                                            :
                                            !item.isDownloaded ?
                                                <div className='button-wrapper cursor-pointer mb-3 mt-4' style={{ background: '#21b8c7' }} onClick={() => this.onClickTestClicker(item, index)}>
                                                    <div className='start-button'>Test Clickers</div>
                                                </div>
                                                :
                                                <div className='button-wrapper mb-3 mt-4' onMouseEnter={ReactTooltip.rebuild} style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                                    <div data-tip={item.isDownloaded ? "This Practice Downloaded in Other System" : 'Use Countingwell Application'} className='start-button'>Test Clickers</div>
                                                </div>
                                        :
                                        <div className='button-wrapper mb-3 mt-4' onMouseEnter={ReactTooltip.rebuild} style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                            <div data-tip={'Use Countingwell Application'} className='start-button'>Test Clickers</div>
                                        </div>

                                }


                                <div className='d-flex mb-2' onMouseEnter={ReactTooltip.rebuild}>
                                    {
                                        CommonUtils.isOnline() && item.isDownloaded && this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ?
                                            <div className={`button-wrapper cursor-pointer`} onClick={() => this.onClickCard(item, index)}>
                                                <div className='start-button'>{'Resume Offline'}</div>
                                            </div>
                                            :
                                            Constants.ELECTRON_BUILD ?
                                                item.isDownloaded && item.isPresentInThisSystem ?
                                                    <div className={`button-wrapper cursor-pointer ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`} onClick={() => this.onClickCard(item, index)}>
                                                        <div className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}</div>
                                                    </div>
                                                    :
                                                    !item.isDownloaded ?
                                                        this.state.type === Constants.CLICKER_CONCEPT_CARD && item.teacherHomeworkActivityStatus === 'ASSIGNED' ?

                                                            <div className={`button-wrapper cursor-pointer ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`} onClick={() => this.showRevisionFlow(item, index)}>
                                                                <div className='start-button' >
                                                                    Start Revision
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={`button-wrapper cursor-pointer ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`} onClick={() => this.onClickCard(item, index)} >

                                                                <div className='start-button' onClick={() => this.onClickCard(item, index)}>

                                                                    {this.getButtonTitle(item.teacherHomeworkActivityStatus)}


                                                                    {/* {this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' && item.resumeQuestionNumber ? ` (${item.resumeQuestionNumber}/${item.approximateQuestions})` : ''} */}
                                                                </div>
                                                            </div>
                                                        :
                                                        <div className={`button-wrapper-disabled ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`}>
                                                            <div data-tip={item.isDownloaded ? "This Practice Downloaded in Other System" : 'Use Countingwell Application'} className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}</div>
                                                        </div>
                                                :
                                                <div className={`button-wrapper-disabled ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`}>
                                                    <div data-tip={'Use Countingwell Application'} className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}</div>
                                                </div>
                                    }
                                </div>
                                {
                                    this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' && item.type != Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                                        <div className='d-flex pt-2'>
                                            <div className='button-wrapper cursor-pointer' style={{ background: '#F1685A' }} onClick={() => this.onClickEndPractice(item, index)}>
                                                <div className='start-button'>{"End Practice"}</div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                }

                                {
                                    this.state.type === Constants.CLICKER_CONCEPT_CARD ?
                                        <></>
                                        :
                                        <div className="download-options" >
                                            <div className="d-flex justify-content-start button-padding mb-2" onMouseEnter={ReactTooltip.rebuild}>
                                                {
                                                    item.isDownloading ?
                                                        <div className="view-answer-wrapper" style={{ background: '#407BFF', border: '#407BFF' }}>
                                                            <div className="d-flex align-items-center justify-content-center view-answer-button">
                                                                <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                                {/* <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Downloading...'}</span> */}
                                                            </div>
                                                        </div>
                                                        :
                                                        item.isDownloaded ?
                                                            <div className="view-answer-wrapper" style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                                                <div className="d-flex align-items-center justify-content-center view-answer-button" >
                                                                    <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Downloaded'}</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            !item.isDownloaded && (item.teacherHomeworkActivityStatus === 'COMPLETED' || item.teacherHomeworkActivityStatus === 'IN_PROGRESS') ?
                                                                <></>
                                                                :
                                                                Constants.ELECTRON_BUILD ?
                                                                    <div className="view-answer-wrapper" style={{ background: '#407BFF', border: '#407BFF' }}>
                                                                        <div className="d-flex align-items-center justify-content-center view-answer-button cursor-pointer" onClick={() => this.updateItem(item._id, item, "DOWNLOAD")}>
                                                                            <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Download'}</span>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className="view-answer-wrapper" style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                                                        <div data-tip={'Use Countingwell Application'} className="d-flex align-items-center justify-content-center view-answer-button " >
                                                                            <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Download'}</span>
                                                                        </div>
                                                                    </div>
                                                }
                                            </div>
                                            {
                                                item.isDownloaded ?
                                                    <div className="d-flex justify-content-start button-padding">

                                                        {
                                                            item.isSynchronizing ?
                                                                <div className="view-answer-wrapper" style={{ background: '#96f2b7', border: '#96f2b7' }}>
                                                                    <div className="text-center view-answer-button">
                                                                        {/* {'Synchronizing...'}
                                                                 */}
                                                                        <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                                    </div>
                                                                </div>
                                                                :
                                                                item.pendingSync && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                                                                    <div className={`view-answer-wrapper ${isOnline ? 'syn-online-button' : 'light-gray-button'} `}>
                                                                        <div className={`text-center view-answer-button ${isOnline ? 'cursor-pointer' : ''} `} onClick={() => this.updateItem(item._id, item, "SYNC")}  >
                                                                            {'Sync Pending'}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    !item.pendingSync && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                                                                        <div className="view-answer-wrapper" >
                                                                            <div className="text-center view-answer-button" >
                                                                                {'Sync Completed'}
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <></>
                                                        }
                                                    </div>
                                                    :
                                                    <></>
                                            }
                                        </div>
                                }



                            </div>
                            <div className='col-2 pt-3 pl-3'>
                                <div className='status-text position-relative'>
                                    Status
                                </div>
                                {
                                    CommonUtils.isOnline() ?
                                        <>
                                            {/* <div className='mt-1 ml-2'>
                                                <img className='clone-icon cursor-pointer' data-tip={"Clone Assignment"}
                                                    src={getImageSource(ImageConstants.CLONE_ICON)}
                                                    onClick={() => this.setState({ showClickerAssignModal: true, selectedHomework: item })} />
                                            </div> */}
                                            {
                                                !item.completed.length ?
                                                    <div ><img data-tip={"Delete Assignment"}
                                                        className='delete-icon cursor-pointer'
                                                        src={getImageSource(ImageConstants.DELETE_RED)}
                                                        onClick={() => this.setState({ showDeletionModal: true, selectedHomework: item })} /></div>
                                                    :
                                                    <></>

                                            }
                                        </>
                                        :
                                        <></>

                                }

                                <div>
                                    {this.renderStatus(item, index)}
                                </div>
                            </div>

                            {
                                CommonUtils.isOnline() ?
                                    <div className='col pr-0 pt-1 reports-border-left'>
                                        <div className='reports-text position-relative'>
                                            Reports
                                            {/* {
                                                !item.baseLineHomeworkId ?
                                                    <div className='cursor-pointer' onClick={() => this.onClickNewHomeWork(item, index, false, true)}>Create Finish Line</div>
                                                    :
                                                    <></>
                                            } */}
                                            {/* <div className='float-right delete-icon'><img src={getImageSource(ImageConstants.DELETE)} /></div> */}
                                        </div>
                                        {/* {
                                            !item.completed.length ?
                                                <div ><img data-tip={"Delete Assignment"}
                                                    className='delete-icon cursor-pointer'
                                                    src={getImageSource(ImageConstants.DELETE)}
                                                    onClick={() => this.setState({ showDeletionModal: true, selectedHomework: item })} /></div>
                                                :
                                                <></>

                                        } */}

                                        {
                                            item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT ?
                                                item.completed ?
                                                    <div className='mb-2 ml-3'>
                                                        {this.getReportList(item, index)}
                                                    </div>

                                                    :
                                                    item.completed && item.completed.length ?
                                                        <div className='mb-2 ml-3'>
                                                            {this.getReportList(item, index)}
                                                        </div>
                                                        :
                                                        <div className='mb-2 ml-3 text-center'>
                                                            No Reports Available. Please Complete this Practice to See the Reports
                                                        </div>
                                                : item.completed && item.completed.length ?
                                                    <div className='mb-2 ml-3'>
                                                        {this.getReportList(item, index)}
                                                    </div>
                                                    :
                                                    <div className='mb-2 ml-3 text-center'>
                                                        No Reports Available. Please Complete this Practice to See the Reports
                                                    </div>

                                        }




                                    </div>
                                    :
                                    <div className='col pr-0 pt-1 reports-border-left'>
                                        <div className='reports-text'>
                                            Reports
                                        </div>
                                        <div className='mb-2 ml-3 text-center'>
                                            Available in Online
                                        </div>
                                    </div>
                            }
                        </>

                }


            </div>
        )
    }

    renderList = () => {

        return (
            <div className='tabs-wrapper'>
                <div className='screen-title mt-3'>{this.state.type === Constants.CLICKER_CONCEPT_CARD ? 'Revise' : 'Classroom Practice'}</div>
                <div className='tabs ml-5'>
                    {this.getTabs()}
                </div>
                {
                    this.state.homeworkList && this.state.homeworkList.length ? this.state.homeworkList?.map((item, index) => (
                        this.renderTableRow(item, index)
                    ))
                        : <div className="bg-white p-4 no-records-text"><div colSpan="5" align='center'>No Record's found</div></div>
                }
            </div>
        )
    }

    showTestResultsReport = (item, index) => {
        this.setState({ showTestResultReport: true, selectedItem: item, selectedItemIndex: index })
    }

    hideTestResultsReport = () => {
        this.hideReport()
        this.setState({ showTestResultReport: false })
    }


    renderReport = () => {

        if (this.state.selectedHomework.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
            if (this.state.selectedReportType === 'HOMEWORK_EVALUATION_REPORT') {
                return <TestResultReport selectedItem={this.state.selectedHomework} delegate={this} />
            }

            if (this.state.selectedReportType === 'MOST_WRONG_REPORT') {
                return <WronglyAnswered type='TEST' show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />
            }

            if (this.state.selectedReportType === 'ALL_QUESTIONS_REPORT') {
                return <AllQuestions delegate={this} close={this.hideReport} selectedItem={this.state.selectedHomework} />
            }

            if (this.state.selectedReportType === 'ELO_LEVEL_REPORT') {
                return <EloReportForAssessment type={this.state.selectedHomework.type} delegate={this} selectedItem={this.state.selectedHomework} />
            }

            if (this.state.selectedReportType === 'RECOMMANDATION_REPORT') {
                return <RecommandationReportForAssessment type="TEST" show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />
            }

            if (this.state.selectedReportType === 'CLASS_PERFORMANCE_REPORT') {
                return <ClassPerformanceReportForAssessment
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                />
            }



        }


        switch (this.state.selectedReportType) {

            case "HOMEWORK_EVALUATION_REPORT":
                return <HomeworkEvalutionReport type={"CLICKER_PRACTICE_STANDARD"} delegate={this} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />

            case "COMPLETION_REPORT":
                return <CompletionReport type={"CLICKER_PRACTICE_STANDARD"} delegate={this} selectedItem={this.state.selectedHomework} />

            // case "LEVEL_PROGRESSION_REPORT":
            //     return <HomeworkProgressionReport type={"CLICKER_PRACTICE_STANDARD"} delegate={this} selectedItem={this.state.selectedHomework} />

            // case "STUDENT_DETAIL_REPORT":
            //     return <StudentDetailReport type={"CLICKER_PRACTICE_STANDARD"} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} onClickBack={this.onClickStudentDetailBack} />

            case "ELO_LEVEL_REPORT":
                return <EloReport type={"CLICKER_PRACTICE_STANDARD"}
                    delegate={this}
                    selectedItem={this.state.selectedHomework}
                    student={this.state.selectedStudent}
                    fromScreen={this.state.fromScreen} />

            case "MOST_WRONG_REPORT":
                return <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />

            case "ALL_QUESTIONS_REPORT":
                return <AllQuestions type={"CLICKER_PRACTICE_STANDARD"} delegate={this} close={this.hideReport} selectedItem={this.state.selectedHomework} />

            case "RECOMMANDATION_REPORT":
                return <RecommandationReport
                    show={this.state.showWrongAnswersReport}
                    delegate={this} close={this.hideWrongAnswersReport}
                    selectedItem={this.state.selectedHomework}
                    from={"CLICKER_PRACTICE_STANDARD"} />

            case "STANDARD_COMPETENCY_REPORT":
                return <ChapterEloAssessmentReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                    from={"CLICKER_PRACTICE_STANDARD"} />

            case "CLASS_PERFORMANCE_REPORT":
                return <ClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                    from={"CLICKER_PRACTICE_STANDARD"} />

            // case "OVERALL_CLASS_PERFORMANCE_REPORT":
            //     return <OverallClassPerformanceReport
            //         delegate={this}
            //         close={this.hideReport}
            //         selectedItem={this.state.selectedHomework}
            //         from={"CLICKER_PRACTICE_STANDARD"} />

            case "SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT":
                return <SchoolworkOverallClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                    from={"CLICKER_PRACTICE_STANDARD"} />

            case "BASELINE_FINISHLINE_REPORT":
                return <BaslineVsFinishLineReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                    from={"CLICKER_PRACTICE_STANDARD"} />

            default:
                break
        }
    }

    renderFilters = () => {
        return (
            <div className='mb-5'>{this.state.selectedFilters.map((filter, index) => (

                Array.isArray(filter.value) ?
                    filter.value?.length ?

                        <div key={'filter' + index} className='mr-2 selected-filter-container mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            {filter.value.map((item, filterIndex) =>
                                <>
                                    <div className='filter-value'>{item.title}</div>
                                </>
                            )}
                        </div>
                        : ""
                    :
                    filter.value ?
                        <div key={'filter' + index} className='selected-filter-container mr-2 mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            <div className='filter-value'>{filter.value}</div>
                        </div>
                        : ""
            ))}
            </div>
        )
    }

    showEloDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideMoreInfoModal} size={'lg'}>
                <ModalBody >
                    <EloDetail back={this.hideMoreInfoModal} item={this.state.selectedHomeworkMore} />
                </ModalBody>
            </Modal>
        )

    }

    onClickDelete = (item) => {
        let payload = { homeworkId: item._id, status: "ARCHIVED" }
        HomeworkApi.updateHomework(payload)
            .then(response => {

                this.setState({ showDeletionModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onClickAssignClickerPractice = (item) => {
        // console.log(item)

        let concepts = item.concepts
        let conceptKeysList = [], eloIdsList = []
        concepts.forEach((concept, index) => {
            conceptKeysList.push({ value: concept.key, order: index + 1 })

            if (concept.elos && concept.elos.length) {
                concept.elos.forEach(elo => {
                    eloIdsList.push({ value: elo.id, conceptValue: concept.key })
                })
            }
        })
        item.conceptKeysList = conceptKeysList
        item.eloIdsList = eloIdsList
        console.log(item)
        this.getClasses()
        this.setState({
            showClickerAssignModal: false, showNewHomework: true,
            isClonePractice: true,
            selectedHomework: item,
            assessmentQuestionType: item.assessmentQuestionType,
            contentsHash: item.contentsHash
        })
    }



    onClickActivate = (item, dueDate) => {
        let payload = {
            homeworkId: item._id, status: "ACTIVE"
        }

        if (dueDate) {
            payload.dueDate = dueDate
        }


        console.log(payload)
        HomeworkApi.updateHomework(payload)
            .then(response => {

                this.setState({ showActiveConfirmationModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onFilterGo = (payload) => {

        if (!payload) {
            this.filter.board = ''
            this.filter.class = ''
            this.filter.section = ''
            this.filter.chapter = ''
            this.filter.concepts = ''
            this.filter.elos = ''
            this.filter.createdDateRangeStart = ''
            this.filter.createdDateRangeEnd = ''
            this.filter.dueDateRangeStart = ''
            this.filter.dueDateRangeEnd = ''
            this.getHomeworkList({ status: this.state.tabs[this.state.activeTabIndex].value })
            this.setState({ selectedFilters: [] })
        } else {

            let filters = []

            let filter = { ...this.filter }

            if (payload.createdDateRangeStart && payload.createdDateRangeEnd) {

                if (payload.createdDateFilter) {
                    filters.push({ type: 'Created Date', value: payload.createdDateFilter })
                }

                this.filter.createdDateRangeStart = payload.createdDateRangeStart
                this.filter.createdDateRangeEnd = payload.createdDateRangeEnd
            }

            if (payload.completedDateRangeStart && payload.completedDateRangeEnd) {

                if (payload.completedDateFilter) {
                    filters.push({ type: 'Created Date', value: payload.completedDateFilter })
                }

                this.filter.completedDateRangeStart = payload.completedDateRangeStart
                this.filter.completedDateRangeEnd = payload.completedDateRangeEnd
            }

            if (payload.dueDateRangeStart && payload.dueDateRangeEnd) {

                if (payload.dueDateFilter) {
                    filters.push({ type: 'Due Date', value: payload.dueDateFilter })
                }

                this.filter.dueDateRangeStart = payload.dueDateRangeStart
                this.filter.dueDateRangeEnd = payload.dueDateRangeEnd
            }

            if (payload.board) {
                filters.push({ type: 'Board', value: payload.board })
                this.filter.board = payload.board
            }

            if (payload.class) {
                filters.push({ type: 'Class', value: payload.class })
                this.filter.class = payload.class
            }

            if (payload.section) {
                if (payload.section) {
                    filters.push({ type: 'Section', value: payload.sectionObject })
                }
                this.filter.section = payload.section
            }

            if (payload.chapter) {
                if (payload.chapterObject) {
                    filters.push({ type: 'Chapter', value: payload.chapterObject.title })
                }
                this.filter.chapter = payload.chapter
            }

            if (payload.concepts) {
                if (payload.conceptsObject) {
                    filters.push({ type: 'Concepts', value: payload.conceptsObject })
                }
                this.filter.concepts = payload.concepts
            }

            if (payload.elos) {
                if (payload.eloObject) {
                    filters.push({ type: 'Learning Outcomes', value: payload.eloObject })
                }
                this.filter.elos = payload.elos
            }

            console.log(this.filter)

            this.setState({ selectedFilters: filters })

            this.getHomeworkList(this.filter)

        }


    }

    onPageSelected = (selectedPage, startIndex) => {
        let payload = {
            page: selectedPage,
        }
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage, selectedItemIndex: null, selectedItemGroupIndex: null })
        this.getHomeworkList(this.filter)
    }

    checkCreateCondtion() {
        return this.accessRights[AccessRights.CLICKER_PRACTICE] && CommonUtils.isOnline()
    }

    checkEditCondtion() {
        if ("CLICKER_PRACTICE_STANDARD" == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_EDIT]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_EDIT]
        }
    }

    onClickStudent = (student) => {
        this.setState({ selectedStudent: student }, () => {
            this.showReport("STUDENT_DETAIL_REPORT", this.state.selectedHomework)
        })
    }

    onClickStudentDetailBack = () => {
        this.showReport("HOMEWORK_EVALUATION_REPORT", this.state.selectedHomework, this.state.selectedItemIndex, this.state.selectedItemGroupIndex)
    }


    showRewardToaster = (item) => {
        if (item.point) {
            this.showToaster('info', `🎁 YAY! You just earned ${item.point} reward points for assigning the ${item.type === 'STANDARD' ? 'Homework' : 'Classwork'} ${item?.totalUsers || 0} students from ${item.class}${item.section ? " " + item.section : ""}`)
        }
    }


    onClickCard(item) {
        if (item.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
            console.log(item)

            let teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item._id]

            if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
                this.layoutShared.state.homeworkItem.homeworkId &&
                this.layoutShared.state.homeworkItem.status != 'COMPLETED') {
                teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item.homeworkId]
            }


            console.log(teacherHomeworkItem)

            if (item.autoNext) {
                teacherHomeworkItem.autoNext = item.autoNext
            }

            if (item.selectedSetId) {
                teacherHomeworkItem.selectedSetId = item.selectedSetId
                teacherHomeworkItem.selectedSetTitle = item.selectedSetTitle
            }

            if (item.teacherHomeworkActivityStatus !== 'COMPLETED') {
                this.setState({ showAssessmentFlow: true, teacherHomeworkItem })
            }
        } else {
            this.getHomeworkStatus(item)
        }
    }


    getHomeworkStatus = (item) => {


        // console.log('>>>>::', item)


        let teacherHomeworkActivity = this.teacherHomeworkActivityStatusHash[item._id]

        // console.log(teacherHomeworkActivity)

        if (teacherHomeworkActivity.status === 'COMPLETED') return
        if (!teacherHomeworkActivity.clickerSet.length) {
            alert('No Clicker Set Found');
            return;
        }

        // console.log('teacherhomework', teacherHomeworkActivity)

        if (teacherHomeworkActivity.isDownloaded && CommonUtils.isOnline) {
            console.log('setting to offline')
            this.layoutShared.forceOffline(true, item)
            // CommonUtils.setOffline()
        }


        let payload = {
            homeworkId: teacherHomeworkActivity.homeworkId
        }

        this.toggleFullScreenLoading(true)

        let clickerPayload = {
            homeworkId: teacherHomeworkActivity.homeworkId,
            class: item.class,
            board: item.board
        }

        if (CommonUtils.isOnline() && !teacherHomeworkActivity.isDownloaded) {
            // CommonApi.getStudentClickerList(clickerPayload).then(response => {
            // console.log(response)
            HomeworkForClickerPracticeApi.getHomeworkStatus(payload).then((res) => {
                console.log(res)
                let concepts = []
                if (teacherHomeworkActivity.conceptsCovered.length) {
                    for (let i = 0; i < teacherHomeworkActivity.conceptsCovered.length; i++) {
                        concepts.push(teacherHomeworkActivity.conceptsCovered[i].title)
                    }
                }

                if (res && res.notAttepmted && res.notAttepmted.length) {
                    if (teacherHomeworkActivity.status === 'ASSIGNED') {
                        this.setState({
                            showStartPracticeScreen: true,
                            // usersList: response.clickerUserList,
                            // showStartAssessment: false,
                            params: {
                                homeworkId: teacherHomeworkActivity.homeworkId,
                                nodeId: res.notAttepmted[0].id,
                                nodes: res.notAttepmted,
                                title: item.chapter ? item.chapter : '',
                                concepts: res.concepts,
                                categoryThemeId: 1,
                                conceptsCovered: concepts,
                                homework: item,
                                typeOfSchoolwork: "CLASSWORK",
                                chapterImageUrl: item.chapterImageUrl ? item.chapterImageUrl : '',
                                status: teacherHomeworkActivity.status,
                                clickerSet: teacherHomeworkActivity.clickerSet
                            }
                        })
                    } else {

                        let payload = {
                            selectedSetId: item.selectedSetId,
                            homeworkId: teacherHomeworkActivity.homeworkId
                        }

                        SchoolApi.getUserClickerList(payload).then(clickerUserRes => {
                            console.log(clickerUserRes)
                            this.setState({
                                showStandardClassworkExperience: true,
                                usersList: clickerUserRes.clickerUserList,
                                // showStartAssessment: false,
                                params: {
                                    homeworkId: teacherHomeworkActivity.homeworkId,
                                    nodeId: res.notAttepmted[0].id,
                                    nodes: res.notAttepmted,
                                    title: item.chapter ? item.chapter : '',
                                    concepts: res.concepts,
                                    categoryThemeId: 1,
                                    conceptsCovered: concepts,
                                    homework: item,
                                    typeOfSchoolwork: "CLASSWORK",
                                    chapterImageUrl: item.chapterImageUrl ? item.chapterImageUrl : '',
                                    status: teacherHomeworkActivity.status
                                }
                            })
                        }).catch(err => {
                            console.log(err)
                        })
                    }
                } else {
                    this.setState({ showHomeworkConceptListScreen: true, homeworkMetaInfo: { details: res, conceptsCovered: concepts, homework: item, homeworkId: item.homeworkId, title: item.chapterTitle, categoryThemeId: 1, chapterImageUrl: item.chapterImageUrl } })
                }
                // })
            }).catch(err => {
                if (err) {
                    return
                }
            })
        } else if (!CommonUtils.isOnline() || teacherHomeworkActivity.isDownloaded) {

            console.log('offline resume')

            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item._id).then(teacherHomeworkActivityData => {
                let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                let userIds = teacherHomeworkActivity.userIdsList
                // To Add Teacher UserId
                userIds.push(teacherHomeworkActivity.userId)


                dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                    clickerUserList = clickerUserList.sort((a, b) => a.studentNumber - b.studentNumber)


                    this.getHomeworkStatusInOffline(item._id, (err, res) => {

                        if (err) {
                            alert('No Homework Status Found')
                        }


                        let concepts = []

                        // if (teacherHomeworkActivity.conceptsCovered.length) {
                        //     for (let i = 0; i < teacherHomeworkActivity.conceptsCovered.length; i++) {
                        //         concepts.push(teacherHomeworkActivity.conceptsCovered[i].title)
                        //     }
                        // }
                        if (res && res.notAttepmted && res.notAttepmted.length) {
                            if (teacherHomeworkActivity.status === 'ASSIGNED') {
                                this.setState({
                                    showStartPracticeScreen: true,
                                    usersList: clickerUserList,
                                    // showStartAssessment: false,
                                    params: {
                                        homeworkId: teacherHomeworkActivity.homeworkId,
                                        nodeId: res.notAttepmted[0].id,
                                        nodes: res.notAttepmted,
                                        title: item.chapter ? item.chapter : '',
                                        concepts: res.concepts,
                                        categoryThemeId: 1,
                                        conceptsCovered: concepts,
                                        homework: item,
                                        typeOfSchoolwork: "CLASSWORK",
                                        chapterImageUrl: item.chapterImageUrl ? item.chapterImageUrl : '',
                                        status: teacherHomeworkActivity.status,
                                        clickerSet: teacherHomeworkActivity.clickerSet
                                    }
                                })
                            } else {


                                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item._id).then(teacherHomeworkActivityData => {
                                    let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                                    let selectedClickerSet = teacherHomeworkActivity.clickerSet.filter(item => item.value === teacherHomeworkActivity.selectedSetId)

                                    let studentClickerList = selectedClickerSet[0].studentClickerList
                                    let teacherClickerId = selectedClickerSet[0].teacherClickerId

                                    let studentClickerListhash = {}

                                    for (let i = 0; i < studentClickerList.length; i++) {
                                        studentClickerListhash[i + 1] = studentClickerList[i]
                                    }

                                    let userIds = teacherHomeworkActivity.userIdsList

                                    let payload = {
                                        selectedSetId: item.selectedSetId,
                                        homeworkId: teacherHomeworkActivity.homeworkId
                                    }

                                    dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                                        console.log(clickerUserList)

                                        clickerUserList = clickerUserList.sort((a, b) => a.studentNumber - b.studentNumber)

                                        clickerUserList.forEach(item => {
                                            if (studentClickerListhash[item.studentNumber]) {
                                                item.userDeviceMacId = studentClickerListhash[item.studentNumber].deviceMacId
                                            }
                                        })

                                        let teacherObj = {
                                            userId: teacherHomeworkActivity.userId,
                                            studentNumber: '1000',
                                            userDeviceMacId: teacherClickerId.deviceMacId,
                                            receivedAnswer: false,
                                            isTeacher: true,
                                        }

                                        clickerUserList.push(teacherObj)


                                        this.setState({
                                            showStandardClassworkExperience: true,
                                            usersList: clickerUserList,
                                            // showStartAssessment: false,
                                            params: {
                                                homeworkId: teacherHomeworkActivity.homeworkId,
                                                nodeId: res.notAttepmted[0].id,
                                                nodes: res.notAttepmted,
                                                title: item.chapter ? item.chapter : '',
                                                concepts: res.concepts,
                                                categoryThemeId: 1,
                                                conceptsCovered: concepts,
                                                homework: item,
                                                typeOfSchoolwork: "CLASSWORK",
                                                chapterImageUrl: item.chapterImageUrl ? item.chapterImageUrl : '',
                                                status: teacherHomeworkActivity.status
                                            }
                                        })
                                    }).catch(err => {
                                        console.log(err)
                                    })
                                })
                            }
                        } else {
                            this.setState({ showHomeworkConceptListScreen: true, homeworkMetaInfo: { details: res, conceptsCovered: concepts, homework: item, homeworkId: item.homeworkId, title: item.chapterTitle, categoryThemeId: 1, chapterImageUrl: item.chapterImageUrl } })
                        }

                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }

    onClickEndPractice = (item) => {
        // console.log('>>>>::', item)
        let teacherHomeworkActivity = this.teacherHomeworkActivityStatusHash[item._id]
        if (teacherHomeworkActivity.status === 'COMPLETED') return
        if (!teacherHomeworkActivity.clickerSet.length) {
            alert('No Clicker Set Found');
            return;
        }


        let payload = {
            homeworkId: teacherHomeworkActivity.homeworkId
        }

        this.toggleFullScreenLoading(true)

        let clickerPayload = {
            homeworkId: teacherHomeworkActivity.homeworkId,
            class: item.class,
            board: item.board
        }

        if (teacherHomeworkActivity.isDownloaded && CommonUtils.isOnline) {
            console.log('setting to offline')
            item.isEndPractice = true
            this.setState({ isLoading: true })
            this.layoutShared.forceOffline(true, item)
            // CommonUtils.setOffline()
        }




        if (CommonUtils.isOnline() && !teacherHomeworkActivity.isDownloaded) {
            HomeworkForClickerPracticeApi.getHomeworkStatus(payload).then((res) => {
                console.log(res)
                let concepts = []
                if (teacherHomeworkActivity.conceptsCovered.length) {
                    for (let i = 0; i < teacherHomeworkActivity.conceptsCovered.length; i++) {
                        concepts.push(teacherHomeworkActivity.conceptsCovered[i].title)
                    }
                }
                if (res && res.notAttepmted && res.notAttepmted.length) {
                    let payload = {
                        selectedSetId: item.selectedSetId,
                        homeworkId: teacherHomeworkActivity.homeworkId
                    }
                    SchoolApi.getUserClickerList(payload).then(clickerUserRes => {
                        // console.log(clickerUserRes)
                        this.getAssessmentContent(res.notAttepmted[0].id,
                            teacherHomeworkActivity.homeworkId,
                            clickerUserRes.clickerUserList, (err, data) => {
                                if (err) {
                                    return;
                                }

                                if (data.resume && data.resume.contentId) {

                                    let resumeIndex = 0;

                                    for (let i = 0; i < data.content.length; i++) {
                                        if (data.content[i].id === data.resume.contentId) {
                                            resumeIndex = i;
                                            break;
                                        }
                                    }

                                    let completedContentIndex = resumeIndex - 1

                                    let endNodeId = data.content[completedContentIndex].nodeId
                                    let endContentId = data.content[completedContentIndex].id

                                    let assessedContentIdsHash = {}

                                    for (let i = 0; i < data.content.length; i++) {
                                        let content = data.content[i]
                                        assessedContentIdsHash[content.id] = true
                                        if (completedContentIndex === i) break;
                                    }

                                    let payload = {
                                        homeworkId: teacherHomeworkActivity.homeworkId,
                                        endNodeId,
                                        endContentId,
                                        assessedContentIdsHash
                                    }

                                    HomeworkForClickerPracticeApi.updateHomeworkNodes(payload).then(updatedNode => {
                                        let payload = {
                                            nodeId: endNodeId,
                                            homeworkId: teacherHomeworkActivity.homeworkId,
                                        }

                                        HomeworkForClickerPracticeApi.assessStandaredHomeworkClickerPracticeNode(payload).then((res) => {
                                            this.getTeacherHomeworkActivities()
                                            this.setState({ isLoading: false })
                                            setTimeout(() => {
                                                this.showToaster('info', "Clicker Flow - Practice Completed successfully")
                                            }, 3000)
                                        })
                                    })
                                }
                            });
                    }).catch(err => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
                }
            }).catch(err => {
                if (err) {
                    return
                }
            })
        } else if (!CommonUtils.isOnline() || teacherHomeworkActivity.isDownloaded) {
            console.log('calling offline end practice')
            // This functionality we will implement later as the Ravi - Ravi Said to implement it on 26.12.2025
            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item._id).then(teacherHomeworkActivityData => {
                let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                let selectedClickerSet = teacherHomeworkActivity.clickerSet.filter(item => item.value === teacherHomeworkActivity.selectedSetId)

                let studentClickerList = selectedClickerSet[0].studentClickerList
                let teacherClickerId = selectedClickerSet[0].teacherClickerId

                let studentClickerListhash = {}

                for (let i = 0; i < studentClickerList.length; i++) {
                    studentClickerListhash[i + 1] = studentClickerList[i]
                }

                let userIds = teacherHomeworkActivity.userIdsList

                let payload = {
                    selectedSetId: item.selectedSetId,
                    homeworkId: teacherHomeworkActivity.homeworkId
                }

                dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                    console.log(clickerUserList)

                    clickerUserList.forEach(item => {
                        if (studentClickerListhash[item.studentNumber]) {
                            item.userDeviceMacId = studentClickerListhash[item.studentNumber].deviceMacId
                        }
                    })

                    let teacherObj = {
                        userId: teacherHomeworkActivity.userId,
                        studentNumber: '1000',
                        userDeviceMacId: teacherClickerId.deviceMacId,
                        receivedAnswer: false,
                        isTeacher: true,
                    }

                    clickerUserList.push(teacherObj)

                    this.getHomeworkStatusInOffline(item._id, (err, res) => {

                        if (err) {
                            alert('No Homework Status Found')
                        }
                        let concepts = []
                        // if (teacherHomeworkActivity.conceptsCovered.length) {
                        //     for (let i = 0; i < teacherHomeworkActivity.conceptsCovered.length; i++) {
                        //         concepts.push(teacherHomeworkActivity.conceptsCovered[i].title)
                        //     }
                        // }
                        if (res && res.notAttepmted && res.notAttepmted.length) {
                            let payload = {
                                selectedSetId: item.selectedSetId,
                                homeworkId: teacherHomeworkActivity.homeworkId
                            }

                            // console.log(clickerUserRes)
                            this.getAssessmentContentOffline(res.notAttepmted[0].id,
                                teacherHomeworkActivity.homeworkId,
                                clickerUserList, (err, data) => {
                                    if (err) {
                                        return;
                                    }

                                    if (data.resume && data.resume.contentId) {

                                        let resumeIndex = 0;

                                        for (let i = 0; i < data.content.length; i++) {
                                            if (data.content[i].id === data.resume.contentId) {
                                                resumeIndex = i;
                                                break;
                                            }
                                        }

                                        // let completedContentIndex = resumeIndex - 1
                                        let completedContentIndex = data.completedQuestionNumber - 1

                                        let endNodeId = data.content[completedContentIndex].nodeId
                                        let endContentId = data.content[completedContentIndex].id

                                        let assessedContentIdsHash = {}

                                        for (let i = 0; i < data.content.length; i++) {
                                            let content = data.content[i]
                                            assessedContentIdsHash[content.id] = true
                                            if (completedContentIndex === i) break;
                                        }

                                        let payload = {
                                            homeworkId: teacherHomeworkActivity.homeworkId,
                                            endNodeId,
                                            endContentId,
                                            assessedContentIdsHash
                                        }


                                        dbHelper.getAllFromIndex(Constants.HOMEWORK_NODES_STORE, 'homeworkId', teacherHomeworkActivity.homeworkId).then((homeworkNodes) => {

                                            if (!homeworkNodes.length) {
                                                // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "Invalid homeworkId" }, res, req);
                                                // callback({ message: "Invalid homeworkId" }, null)
                                                return;
                                            }

                                            let nodeIndex = homeworkNodes.findIndex(element => element._id.toString() === endNodeId)

                                            if (nodeIndex != homeworkNodes.length) {
                                                homeworkNodes = CommonUtils.sortPayload(homeworkNodes)

                                                let deleteNodeIds = [], isDelete = false

                                                homeworkNodes.forEach(item => {
                                                    if (item._id === endNodeId) {
                                                        isDelete = true
                                                        item.nextNode = null
                                                        item.endContentId = endContentId
                                                    } else if (isDelete) {
                                                        deleteNodeIds.push(item._id)
                                                    }
                                                })

                                                dbHelper.updateBulkData(Constants.HOMEWORK_NODES_STORE, homeworkNodes).then(updatedHomeworkNodes => {

                                                    dbHelper.deleteBulkByIds(Constants.HOMEWORK_NODES_STORE, deleteNodeIds).then(homeworkNodesDeletedRes => {

                                                        dbHelper.getData(Constants.HOMEWORK_STORE, teacherHomeworkActivity.homeworkId).then(homeworkData => {

                                                            homeworkData.approximateQuestions = Object.keys(assessedContentIdsHash).length
                                                            homeworkData.assessedContentIdsHash = assessedContentIdsHash
                                                            homeworkData = [homeworkData]

                                                            dbHelper.updateBulkData(Constants.HOMEWORK_STORE, homeworkData).then(updatedHomeworkNodes => {

                                                                this.assessNodeOffline(res.notAttepmted[0].id,
                                                                    teacherHomeworkActivity.homeworkId,
                                                                    clickerUserList, (err, assessedNodeData) => {
                                                                        console.log('node assessment completed 1')
                                                                        teacherHomeworkActivity = [teacherHomeworkActivity]
                                                                        teacherHomeworkActivity[0].status = 'COMPLETED'
                                                                        teacherHomeworkActivity[0].pendingSync = true
                                                                        dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherHomeworkActivity).then((updateInfo) => {
                                                                            this.getTeacherHomeworkActivities()
                                                                            setTimeout(() => {
                                                                                this.showToaster('info', "Clicker Flow - Practice Completed successfully")
                                                                                if (!CommonUtils.isOnline() && navigator.onLine) {
                                                                                    this.layoutShared.forceOffline(false)
                                                                                }
                                                                            }, 3000)
                                                                        })
                                                                    })
                                                            })
                                                        })
                                                    })
                                                })

                                            } else {
                                                this.assessNodeOffline(res.notAttepmted[0].id,
                                                    teacherHomeworkActivity.homeworkId,
                                                    clickerUserList, (err, assessedNodeData) => {
                                                        console.log('node assessment completed 2')
                                                        teacherHomeworkActivity = [teacherHomeworkActivity]
                                                        teacherHomeworkActivity[0].status = 'COMPLETED'
                                                        teacherHomeworkActivity[0].pendingSync = true
                                                        dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherHomeworkActivity).then((updateInfo) => {
                                                            this.getTeacherHomeworkActivities()
                                                            setTimeout(() => {
                                                                this.showToaster('info', "Clicker Flow - Practice Completed successfully")
                                                                if (!CommonUtils.isOnline() && navigator.onLine) {
                                                                    this.layoutShared.forceOffline(false)
                                                                }
                                                            }, 3000)

                                                        })
                                                    })
                                            }
                                        })
                                    }
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })


            HomeworkForClickerPracticeApi.getHomeworkStatus(payload).then((res) => {
                console.log(res)
                let concepts = []
                if (teacherHomeworkActivity.conceptsCovered.length) {
                    for (let i = 0; i < teacherHomeworkActivity.conceptsCovered.length; i++) {
                        concepts.push(teacherHomeworkActivity.conceptsCovered[i].title)
                    }
                }
                if (res && res.notAttepmted && res.notAttepmted.length) {
                    let payload = {
                        selectedSetId: item.selectedSetId,
                        homeworkId: teacherHomeworkActivity.homeworkId
                    }
                    SchoolApi.getUserClickerList(payload).then(clickerUserRes => {
                        // console.log(clickerUserRes)
                        this.getAssessmentContent(res.notAttepmted[0].id,
                            teacherHomeworkActivity.homeworkId,
                            clickerUserRes.clickerUserList, (err, data) => {
                                if (err) {
                                    return;
                                }

                                if (data.resume && data.resume.contentId) {

                                    let resumeIndex = 0;

                                    for (let i = 0; i < data.content.length; i++) {
                                        if (data.content[i].id === data.resume.contentId) {
                                            resumeIndex = i;
                                            break;
                                        }
                                    }

                                    let completedContentIndex = resumeIndex - 1

                                    let endNodeId = data.content[completedContentIndex].nodeId
                                    let endContentId = data.content[completedContentIndex].id

                                    let assessedContentIdsHash = {}

                                    for (let i = 0; i < data.content.length; i++) {
                                        let content = data.content[i]
                                        assessedContentIdsHash[content.id] = true
                                        if (completedContentIndex === i) break;
                                    }

                                    let payload = {
                                        homeworkId: teacherHomeworkActivity.homeworkId,
                                        endNodeId,
                                        endContentId,
                                        assessedContentIdsHash
                                    }

                                    HomeworkForClickerPracticeApi.updateHomeworkNodes(payload).then(updatedNode => {
                                        let payload = {
                                            nodeId: endNodeId,
                                            homeworkId: teacherHomeworkActivity.homeworkId,
                                        }

                                        HomeworkForClickerPracticeApi.assessStandaredHomeworkClickerPracticeNode(payload).then((res) => {
                                            this.getTeacherHomeworkActivities()
                                            setTimeout(() => {
                                                this.showToaster('info', "Clicker Flow - Practice Completed successfully")
                                            }, 3000)
                                        })
                                    })
                                }
                            });
                    }).catch(err => {
                        console.log(err)
                    })
                }
            }).catch(err => {
                if (err) {
                    return
                }
            })
        }
    }

    assessNodeOffline(nodeId, homeworkId, studentList, callback) {

        console.log('inside assess node')

        let payload = {
            nodeId,
            homeworkId
        }

        let req = {
            body: { ...payload }
        }

        // let userId = reqDetails.userId ? reqDetails.userId : '';
        // let nodeId = req.body.nodeId ? req.body.nodeId : '';
        // let transferKey = req.profile.transferKey;
        // let experienceFilter = buildExperienceFilter(metaInfo);

        // let homeworkId = req.body.homeworkId;

        // let boardId = reqDetails.boardId ? reqDetails.boardId : '';

        let userIds = [], userIdNodeIdHomeworkIdList = [], teacherUserId = ''

        studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)

                let id = item.userId + payload.nodeId + payload.homeworkId

                userIdNodeIdHomeworkIdList.push(id)

            } else {
                teacherUserId = item.userId
                let id = item.userId + payload.nodeId + payload.homeworkId
                userIdNodeIdHomeworkIdList.push(id)
            }
        })

        console.log(userIdNodeIdHomeworkIdList)

        dbHelper.getAllByIds(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then(nodeActivityResponse => {
            console.log(nodeActivityResponse)
            if (nodeActivityResponse.length === 0) {
                // sendCustomErrorResponse('Couldn\'t find any node activity for given node Id.', res, req)
                console.log('Couldn\'t find any node activity for given node Id.');
                alert('Couldn\'t find any node activity for given node Id.');
                return;
            }

            let nodeActivity = nodeActivityResponse[0];

            if (nodeActivity.resume && nodeActivity.resume.node &&
                nodeActivity.resume.node.elos && nodeActivity.resume.node.elos.length > 0) {

                let eloIdList = [];

                try {
                    nodeActivity.resume.node.elos.map(eloObj => {
                        eloIdList.push(eloObj["id"])
                    });
                } catch (err) {
                    console.log('Found invalid elo Id.');
                    alert('Found invalid elo Id.');
                    return;
                }
                let nodeType = nodeActivity.resume.nodeType;

                dbHelper.getAllByIds(Constants.ELO_STORE, eloIdList).then((eloDetails) => {
                    console.log(eloDetails)
                    let contentIdList = [];
                    let eloThresholdMapping = {};
                    let eloDetailsHash = {};
                    let questionMetaMapping = {};

                    console.log(eloDetails)

                    eloDetails.map((eloObj) => {

                        eloThresholdMapping[eloObj['_id']] = eloObj['threshold'];
                        //elo PK
                        eloDetailsHash[eloObj['_id']] = eloObj;

                        if (eloObj.objects && eloObj.objects.assessment) {

                            eloObj.objects.assessment.map(content => {

                                try {
                                    contentIdList.push((content['contentId']));

                                    // Will be used when aswered wrongly
                                    questionMetaMapping[content['contentId']] = (content['metaDataId']);
                                } catch (e) {
                                    console.log('Found invalid content Id.');
                                    alert('Found invalid content Id.');
                                    return;
                                }
                            })
                        }

                        if (eloObj.objects.homeworkQuestions && eloObj.objects.homeworkQuestions.length) {

                            let noActiveQuestions = false

                            let c1contentIdList = eloObj.objects.homeworkQuestions.map((content) => {
                                if (content.status) {
                                    return content.contentId
                                }
                            });

                            if (c1contentIdList.length) {
                                contentIdList.push(...c1contentIdList)
                            }

                        }
                    });

                    if (contentIdList.length === 0) {

                        // sendCustomErrorResponse('Couldn\'t find any content Ids for given node Id.', res, req)
                        console.log('Couldn\'t find any content Ids for given node Id.');
                        alert('Couldn\'t find any content Ids for given node Id.');
                        return;
                    }

                    eloIdList.map((id, i) => { eloIdList[i] = String(eloIdList[i]) });

                    let attemptNumber = nodeActivity.totalAttempts;

                    dbHelper.getAllByIds(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then((eloActivity) => {

                        console.log(eloActivity)

                        if (eloActivity.length === 0) {
                            console.log('Couldn\'t find any elo activity documents for given node Id.');
                            alert('Couldn\'t find any elo activity documents for given node Id.');
                            // sendCustomErrorResponse('Couldn\'t find any elo activity documents for given node Id.', res, req)
                            return;
                        }

                        let parallelQuestionSet = []

                        eloActivity.map((elo) => {
                            if (elo.isParallelSet) {
                                parallelQuestionSet.push(...elo.questionsToPresent);
                            }
                        })

                        let questionList = parallelQuestionSet.map((question) => question.id);

                        let eloActivityUpdateQuery = { nodeId, attemptNumber, homeworkId };

                        contentIdList.push(...questionList)

                        console.log(contentIdList)
                        contentIdList = contentIdList.filter(item => item != undefined)

                        let contentListQuery = { "_id": { "$in": contentIdList } };

                        dbHelper.getAllByIds(Constants.CONTENTS_STORE, contentIdList).then((contentDetails) => {

                            if (contentDetails.length === 0) {
                                console.log('Couldn\'t find any questions for given node Id.');
                                alert('Couldn\'t find any questions for given node Id.');
                                // sendCustomErrorResponse('Couldn\'t find any questions for given node Id.', res, req)
                                return;
                            }

                            let questionDetailsMapping = {};


                            for (let i = 0; i < contentDetails.length; i++) {

                                let questionId = contentDetails[i]._id;
                                questionDetailsMapping[questionId] = contentDetails[i];
                            }

                            this.calculateThresholdOffline(req, req.database, questionDetailsMapping, eloActivity,
                                eloThresholdMapping, eloActivityUpdateQuery, eloIdList,
                                nodeType, questionMetaMapping, eloDetailsHash, nodeActivity, 'boardId', 'metaInfo', 'experienceFilter', nodeActivityResponse)
                                .then((response) => {

                                    let homeworkNodeQuery = {
                                        homeworkId
                                    };

                                    dbHelper.getAllFromIndex(Constants.HOMEWORK_NODES_STORE, 'homeworkId', homeworkId).then((homeworkNodes) => {

                                        if (!homeworkNodes.length) {
                                            // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "Invalid homeworkId" }, res, req);
                                            callback({ message: "Invalid homeworkId" }, null)
                                            return;
                                        }


                                        homeworkNodes = CommonUtils.sortPayload(homeworkNodes)

                                        let marks = 0

                                        if (nodeId == homeworkNodes[homeworkNodes.length - 1]._id.toString()) {

                                            let updateTeacherActivityQuery = {
                                                homeworkId
                                            }

                                            let updateTeacherActivityPayload = {
                                                status: 'COMPLETED'
                                            }

                                            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkId).then(teacherActivityData => {

                                                teacherActivityData[0].status = 'COMPLETED'
                                                teacherActivityData[0].pendingSync = true

                                                dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivityData).then((updateInfo) => {
                                                    console.log(response)
                                                    callback(null, response)

                                                    // generateChapterAssessmentQuestions(req, homeworkId, (err, practiceQuestionWiseStudentInfo) => {
                                                    //     response.practiceQuestionWiseStudentInfo = practiceQuestionWiseStudentInfo

                                                    //     Responder.sendResponse(StatusCode.SUCCESS, response, res, req);

                                                    // })
                                                })
                                                // addTeacherReward(req, { type: "HOMEWORK_COMPLETION", activityId: homeworkId })
                                                // moengageTracking(req);
                                            })
                                        } else
                                            // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);
                                            callback(null, response)
                                    })
                                }).catch(err => {

                                    // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: err.stack }, res, req);
                                    callback('err', null)

                                });
                        });
                    });
                })
            } else {
                // sendCustomErrorResponse('Found invalid data in node user activity', res, req)
                console.log('Found invalid data in node user activity');
                alert('Found invalid data in node user activity');
                callback('err', null)
            }
        }).catch(err => {
            console.log(err)
        })
    }


    calculateThresholdOffline(req, db, questionDetails, eloActivity, eloThresholdMapping,
        eloActivityUpdateQuery, orderedEloList, nodeType, questionMetaMapping, eloDetailsHash, nodeActivity, boardId, metaInfo, experienceFilter, nodeActivityResponse) {
        console.log('calculate threshould called')
        return new Promise((resolve, reject) => {

            // let clearedElos = [];
            // let notClearedElos = [];
            let userClearedNotClearedEloHash = {}
            let eloActivityQuery = [];
            let failedElos = [];
            let eloWrongAnswerMetaDataIdList = [];
            let isContinue = false;

            let nodeId = eloActivityUpdateQuery['nodeId'];
            // let userId = eloActivityUpdateQuery['userId'];
            let attemptNumber = eloActivityUpdateQuery['attemptNumber'];
            let homeworkId = eloActivityUpdateQuery['homeworkId'];
            // let transferKey = req.profile.transferKey;


            eloActivity.forEach(eloActivity => {

                let eloActivityAnswers = eloActivity.answers;
                let questionIds = Object.keys(eloActivityAnswers);
                let totalQuestions = questionIds.length;
                let notClearedContent = [];
                let clearedElos = [];
                let notClearedElos = [];

                let totalMark = 0;
                let markScored = 0;

                console.log(totalQuestions)

                questionIds.forEach((totalQuestions, j) => {
                    let questionId = questionIds[j];
                    if (eloActivityAnswers[questionId] && eloActivityAnswers[questionId].status == 'IN_CORRECT') {
                        notClearedContent.push(questionId);

                        //will be used to capture knows and dont knows
                        eloWrongAnswerMetaDataIdList.push({
                            contentMetaDataId: questionMetaMapping[questionId], //will contentMetaDataId be type Object
                            eloId: eloActivity.eloId,
                            answer: eloActivityAnswers[questionId]
                        });
                    } else
                        markScored += eloActivityAnswers[questionId] && eloActivityAnswers[questionId].mark ? eloActivityAnswers[questionId].mark : 0

                    totalMark += eloActivityAnswers[questionId] && eloActivityAnswers[questionId].mark ? eloActivityAnswers[questionId].mark : 0;
                })

                let threshold = ((totalQuestions - notClearedContent.length) / totalQuestions) * 100;

                let eloId = eloActivity.eloId;

                let status = '';

                let score = {
                    value: threshold,
                    type: "%",
                    state: ""
                };

                if (threshold >= eloThresholdMapping[eloId].value) {
                    clearedElos.push({
                        id: eloId,
                        title: eloDetailsHash[eloId].title
                    });
                    status = "CLEARED";
                    score.state = "pass"
                } else {

                    notClearedElos.push({
                        id: eloId,
                        title: eloDetailsHash[eloId].title
                    });
                    status = "NOT_CLEARED";
                    score.state = "fail"
                    failedElos.push(eloId);

                }

                userClearedNotClearedEloHash[eloActivity.userId + '_' + eloActivity.transferKey] = { clearedElos, notClearedElos, failedElos }

                let updatedEloActivityPayload = {
                    status,
                    score,
                    lastUpdatedDate: new Date(),
                    totalMark,
                    markScored
                };

                eloActivity.status = status
                eloActivity.score = score
                eloActivity.lastUpdatedDate = new Date()
                eloActivity.totalMark = totalMark
                eloActivity.markScored = markScored

                // let filter = addExperienceFilter({ nodeId, userId, attemptNumber, eloId, homeworkId, transferKey }, experienceFilter);
                // eloActivity = { ...eloActivity, status, score, lastUpdatedDate: new Date(), totalMark, markScored }
            })

            console.log(eloActivity)


            dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivity).then((status) => {

                let nodeActivityQuery = [], updatedNodeActivityReponse = []

                nodeActivityResponse.forEach(nodeActivityItem => {
                    let clearedElos = userClearedNotClearedEloHash[nodeActivityItem.userId + '_' + nodeActivityItem.transferKey].clearedElos
                    let failedElos = userClearedNotClearedEloHash[nodeActivityItem.userId + '_' + nodeActivityItem.transferKey].failedElos
                    let overAllProgressValue = (clearedElos.length / Object.keys(eloThresholdMapping).length) * 100;

                    let progress = {
                        value: overAllProgressValue,
                        type: '%'
                    };
                    let nodeActivityStatus = overAllProgressValue === 100 ? "CLEARED" : "NOT_CLEARED";


                    let orderedFailedList = [];
                    orderedEloList.filter(elo => {
                        if (failedElos.includes(elo)) {
                            orderedFailedList.push({ "id": elo })
                        }
                    });

                    let obj = {
                        ...nodeActivityItem,
                        status: nodeActivityStatus
                    }

                    updatedNodeActivityReponse.push(obj)
                })

                console.log(updatedNodeActivityReponse)

                dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, updatedNodeActivityReponse).then((status) => {
                    // return resolve({ progress, cleared: clearedElos, notCleared: notClearedElos })
                    return resolve({
                        progress: {
                            value: 0,
                            type: '%'
                        }, cleared: [], notCleared: []
                    })

                });
            }).catch(err => {
                console.log(err)
            })
        });
    }


    getAssessmentContent = (nodeId, homeworkId, studentList, callback) => {

        let payload = {
            nodeId,
            homeworkId
        };

        let userIds = []

        studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)
            }
        })

        console.log(userIds)

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }


        HomeworkForClickerPracticeApi.getStandardHomeworkClickerPracticeAssessment(payload).then((data) => {
            callback && callback(null, data);
        }).catch(err => {
            callback && callback(err, null);
        })
    }

    assessNode(callback) {

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        }

        HomeworkForClickerPracticeApi.assessStandaredHomeworkClickerPracticeNode(payload).then((res) => {

            if (callback)
                callback(null, res);

        }).catch(err => {
            if (callback)
                callback(err, null);
        })

    }



    getHomeworkStatusInOffline(homeworkId, callback) {
        let userInfo = SessionCache.getUser()
        let userId = userInfo.id

        dbHelper.getAllFromIndex(Constants.HOMEWORK_NODES_STORE, "homeworkId", homeworkId).then(homeworkNodes => {
            homeworkNodes = CommonUtils.sortPayload(homeworkNodes)

            let userIdHomeworkId = userId + homeworkId

            dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, "userIdHomeworkId", userIdHomeworkId).then(nodeActivity => {

                console.log(nodeActivity)

                let nodeActivityHash = {}

                for (let i = 0; i < nodeActivity.length; i++) {
                    nodeActivityHash[nodeActivity[i].nodeId] = nodeActivity[i];
                }
                let cleared = []
                let notCleared = []
                let notAttepmted = []

                let conceptsHash = {}
                let concepts = []

                for (let i = 0; i < homeworkNodes.length; i++) {
                    let node = homeworkNodes[i]

                    let obj = {
                        id: node._id.toString(),
                        chapterKey: node.chapterKey,
                        conceptKey: node.conceptKey,
                        chapterTitle: node.chapterTitle,
                        conceptTitle: node.conceptTitle
                    }

                    if (!conceptsHash[node.conceptKey]) {
                        concepts.push({
                            title: node.conceptTitle,
                            key: node.conceptKey
                        })
                        conceptsHash[node.conceptKey] = {}
                    }

                    let activity = nodeActivityHash[node._id.toString()]

                    if (activity) {

                        if (activity.status == "CLEARED") {
                            obj.status = "CLEARED"
                            cleared.push(obj)

                        } else if (activity.status == "IN_PROGRESS" && activity.totalAttempts == 1) {

                            obj.status = "IN_PROGRESS"

                            notAttepmted.push(obj)

                        } else if (activity.status == "NOT_CLEARED") {

                            obj.status = activity.status

                            if (activity.status == "NOT_CLEARED" && activity.totalAttempts == 1) {
                                obj.isStart = true
                            }

                            notCleared.push(obj)
                        }

                    } else {

                        if (!notAttepmted.length) {
                            obj.status = "START"
                        } else {
                            obj.status = "LOCKED"
                        }

                        notAttepmted.push(obj)
                    }
                }

                let responsePayload = {
                    cleared,
                    notCleared,
                    notAttepmted,
                    concepts
                }

                console.log('res', responsePayload)

                callback(null, responsePayload)
            })
        }).catch(err => {
            console.log(err)
        })

    }

    getAssessmentContentOffline = (nodeId, homeworkId, studentList, callback) => {

        // let homeworkId = this.params.homeworkId
        // let nodeId = this.params.nodeId

        let metaInfo = {};

        metaInfo.experienceType = "CLICKER_PRACTICE";
        metaInfo.activity = {
            type: "CLICKER_PRACTICE",
            version: 1
        }

        let payload = {
            nodeId,
            homeworkId
        };

        let userIds = [], teacherUserId = ''

        studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)
            } else {
                teacherUserId = item.userId
            }
        })

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }


        // let userObjectIdList = payload.userIds.split(',').map(item => ObjectID(item))

        let userIdNodeIdHomeworkId = teacherUserId + payload.nodeId + payload.homeworkId



        dbHelper.getData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, userIdNodeIdHomeworkId).then(nodeActivities => {

            console.log('node activities', nodeActivities)

            dbHelper.getData(Constants.HOMEWORK_STORE, homeworkId).then(homeworkData => {

                let assessmentQuestionType = homeworkData.assessmentQuestionType
                let contentsHash = homeworkData.contentsHash


                if (!nodeActivities) {

                    let homeworkNodeQuery = {
                        homeworkId
                    };



                    dbHelper.getData(Constants.HOMEWORK_NODES_STORE, nodeId).then(nodes => {
                        console.log(nodes)
                        nodes = [nodes]
                        if (nodes.length > 0) {

                            let nodeActivity = this.createNodeActivity(teacherUserId, nodes[0], homeworkId, metaInfo);

                            // Store Node Activity for the First Time

                            dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, nodeActivity).then((status) => {

                                nodeActivity = nodeActivity[0]

                                // Update Teacher Homework Acticity
                                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkId).then((teacherActivityData) => {

                                    teacherActivityData[0].status = 'IN_PROGRESS'

                                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivityData).then(updatedTeacherActivity => {

                                        let usersList = studentList

                                        // let eloQuery = { _id: ObjectID(nodeActivity.resume.eloId) };
                                        // Get Elo Details 

                                        dbHelper.getData(Constants.ELO_STORE, nodeActivity.resume.eloId).then((eloDetails) => {

                                            eloDetails = [eloDetails]

                                            console.log(eloDetails)

                                            let assessmentQuestionsIds = this.prepareQueryForAssessmentContent(eloDetails[0]);
                                            let assessmentQuestionsMetadataIds = this.prepareQueryForAssessmentMetadata(eloDetails[0]);
                                            let elo = eloDetails[0];
                                            let videoContentUrl = ''

                                            assessmentQuestionsIds = assessmentQuestionsIds.filter(item => item != undefined)

                                            // console.log(assessmentQuestionsIds)

                                            dbHelper.getAllByIds(Constants.CONTENTS_STORE, assessmentQuestionsIds).then((assessmentContents) => {

                                                assessmentQuestionsMetadataIds = assessmentQuestionsMetadataIds.filter(item => item != undefined)

                                                dbHelper.getAllByIds(Constants.CONTENT_META_DATA_STORE, assessmentQuestionsMetadataIds).then(contentMetaData => {

                                                    let questions = []

                                                    questions = assessmentContents ? assessmentContents : []


                                                    console.log(questions)

                                                    // To not show the Type 7 Labeling Questions // Show only Single Select Questions from Worksheet masterdata

                                                    questions = questions.filter(question => {
                                                        return (question.content.type === 1 || (question.content.isMultiStep && question.content.practice && question.content.practice.id === 'CASE STUDY'))
                                                    }
                                                    )

                                                    if (questions.length == 0) {
                                                        console.log("Question Filter : No Question can be presented in this ELO <", elo["_id"].toString(), ">");
                                                        console.log('No Questios Found')
                                                        // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: "Internal error" }, res, req);
                                                        return;
                                                    }

                                                    if (assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS' && contentsHash) {
                                                        questions = questions.filter(item => contentsHash[item._id.toString()] === true)
                                                    }

                                                    // To update Image in Offline 

                                                    questions.forEach(contentItem => {
                                                        let content = contentItem.content
                                                        if (content.images && content.images.length) {
                                                            content.images.forEach(item => {
                                                                delete item.imageUrl
                                                                item.imageUrl = URL.createObjectURL(item.imageBlob)
                                                            })
                                                        }

                                                        if (content.options && content.options.length) {
                                                            content.options.forEach(option => {
                                                                if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                                                    delete option.content
                                                                    option.content = URL.createObjectURL(option.imageBlob)
                                                                }
                                                            })
                                                        }


                                                        // For Multi Step

                                                        if (content.isMultiStep && content.steps && content.steps.length) {
                                                            content.steps.forEach(stepContentItem => {
                                                                let stepContent = stepContentItem.content
                                                                if (stepContent.images && stepContent.images.length) {
                                                                    stepContent.images.forEach(item => {
                                                                        delete item.imageUrl
                                                                        item.imageUrl = URL.createObjectURL(item.imageBlob)
                                                                    })
                                                                }

                                                                if (stepContent.options && stepContent.options.length) {
                                                                    stepContent.options.forEach(option => {
                                                                        if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                                                            delete option.content
                                                                            option.content = URL.createObjectURL(option.imageBlob)
                                                                        }
                                                                    })
                                                                }

                                                            })
                                                        }
                                                    })


                                                    let questionsByCategory = this.groupByQuestionCategory(questions, contentMetaData, homeworkId);

                                                    let categories = Object.keys(questionsByCategory);
                                                    categories = categories.sort();

                                                    if (categories.length > 0) {
                                                        let eloActivityPayload = {
                                                            userIdNodeIdHomeworkId,
                                                            nodeId: nodeActivity.nodeId,
                                                            // questionCategory: 'M1',
                                                            eloId: elo["_id"].toString(),
                                                            attemptNumber: 1,
                                                            answers: {},
                                                            studentAnswers: {},
                                                            type: "PRIMARY",
                                                            status: "IN_PROGRESS",
                                                            createdDate: new Date(),
                                                            homeworkId: nodeActivity.homeworkId,

                                                            userId: teacherUserId,
                                                            class: teacherActivityData[0].class,
                                                            schoolId: teacherActivityData[0].schoolId,
                                                            // school: teacherActivityData[0].school,
                                                            board: teacherActivityData[0].board,
                                                            // boardId: teacherActivityData[0].boardId,
                                                            section: teacherActivityData[0].section,
                                                            masterDataId: teacherActivityData[0].masterDataId,
                                                            transferKey: "SCHOOL_TEACHER_TRANSFER_KEY",
                                                            alternateBoard: teacherActivityData[0].board,
                                                            ...metaInfo
                                                        };

                                                        dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, [eloActivityPayload]).then((err, status) => {

                                                            // let questionSet = questionsByCategory['M1'];
                                                            let questionSet = questions

                                                            let questionSetQuestions = []
                                                            questionSetQuestions = questionSet
                                                            // Order the Questions as ther Order in the Elo Collection homeworkQuestions order or assessment order

                                                            let questionSetQuestionsHash = {}

                                                            questionSetQuestions.forEach(question => questionSetQuestionsHash[question._id.toString()] = question)

                                                            let orderedQuestionSetQuestions = []

                                                            let eloObjectDetails = eloDetails[0]

                                                            if (eloObjectDetails.objects.homeworkQuestions && eloObjectDetails.objects.homeworkQuestions.length) {

                                                                eloObjectDetails.objects.homeworkQuestions.map((content) => {
                                                                    if (content.status) {
                                                                        let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                        if (contentDetails) {
                                                                            orderedQuestionSetQuestions.push(contentDetails)
                                                                        }

                                                                    }
                                                                });
                                                            }


                                                            eloObjectDetails.objects.assessment.map((content) => {
                                                                let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                if (contentDetails) {

                                                                    if (contentDetails.content.competency && contentDetails.content.competency.id === 'YES' && metaInfo.showTimer) {

                                                                        if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                                                            contentDetails.content.duration = '1.5'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                                                            contentDetails.content.duration = '2'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                                                            contentDetails.content.duration = '2'
                                                                        }


                                                                    } else if (metaInfo.showTimer) {
                                                                        if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                                                            contentDetails.content.duration = '1.5'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                                                            contentDetails.content.duration = '2'
                                                                        }
                                                                    }

                                                                    orderedQuestionSetQuestions.push(contentDetails)
                                                                }
                                                            });
                                                            // }

                                                            if (!orderedQuestionSetQuestions.length) {
                                                                eloObjectDetails.objects.assessment.map((content) => {
                                                                    let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                    if (contentDetails) {
                                                                        orderedQuestionSetQuestions.push(contentDetails)
                                                                    }
                                                                });
                                                            }

                                                            let response = this.getAssessmentContentResponse(orderedQuestionSetQuestions);
                                                            response.content.map((q) => {
                                                                q['eloId'] = elo["_id"].toString();
                                                                q['categoryThemeId'] = elo["categoryThemeId"];
                                                                q['details']['eloTitle'] = elo['title']
                                                                q['details']['videoUrl'] = videoContentUrl
                                                            });
                                                            let position = this.getEloPosition(nodeActivity, elo["_id"].toString());
                                                            response = {
                                                                ...response,
                                                                ...position
                                                            }

                                                            dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', homeworkId).then((eloActivityData) => {
                                                                let completedQuestionNumber = 0

                                                                // console.log(eloActivityData)

                                                                eloActivityData = eloActivityData.filter(item => item.userId === teacherUserId)

                                                                if (eloActivityData && eloActivityData.length) {

                                                                    eloActivityData.forEach(activity => {
                                                                        if (Object.keys(activity.answers).length) {
                                                                            completedQuestionNumber += Object.keys(activity.answers).length
                                                                        }
                                                                    })
                                                                }

                                                                // console.log(completedQuestionNumber)

                                                                response['completedQuestionNumber'] = completedQuestionNumber

                                                                // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);
                                                                console.log(response)
                                                                callback && callback(null, response);


                                                                // Create the Activity for all the Clicker Users

                                                                let homeworkNodeActivityInsertPayload = [],
                                                                    eloActivityPayload = [], userHomeworkActivityUpdatePayload = []

                                                                for (let i = 0; i < usersList.length; i++) {
                                                                    let user = usersList[i]
                                                                    let userIdNodeIdHomeworkId = user.userId + nodeId + homeworkId
                                                                    let nodeActivity = {
                                                                        userIdNodeIdHomeworkId,
                                                                        userIdHomeworkId: user.userId + homeworkId,
                                                                        nodeId: nodes[0]['_id'].toString(),
                                                                        userId: user.userId,
                                                                        homeworkId,
                                                                        primaryNode: nodes[0],
                                                                        totalAttempts: 1,
                                                                        status: "IN_PROGRESS",
                                                                        createdDate: new Date(),
                                                                        resume: {
                                                                            type: 'ASSESSMENT',
                                                                            eloId: nodes[0].elos[0].id,
                                                                            contentId: null,
                                                                            node: nodes[0],
                                                                            nodeType: 'NORMAL'
                                                                        },
                                                                        board: teacherActivityData[0].board,
                                                                        class: teacherActivityData[0].class,
                                                                        masterDataId: teacherActivityData[0].masterDataId,
                                                                        transferKey: user.transferKey, // Need to Update
                                                                        ...metaInfo
                                                                    };

                                                                    homeworkNodeActivityInsertPayload.push(nodeActivity)

                                                                    let eloActivityObject = {
                                                                        userIdNodeIdHomeworkId,
                                                                        nodeId: nodeActivity.nodeId,
                                                                        questionCategory: 'M11',
                                                                        eloId: elo["_id"].toString(),
                                                                        attemptNumber: 1,
                                                                        answers: {},
                                                                        type: "PRIMARY",
                                                                        status: "IN_PROGRESS",
                                                                        createdDate: new Date(),
                                                                        homeworkId: nodeActivity.homeworkId,
                                                                        userId: user.userId,
                                                                        class: teacherActivityData[0].class,
                                                                        schoolId: teacherActivityData[0].schoolId,
                                                                        // school: teacherActivityData[0].schoolName,
                                                                        board: teacherActivityData[0].board,
                                                                        // boardId: teacherActivityData[0].boardId,
                                                                        section: teacherActivityData[0].section,
                                                                        masterDataId: teacherActivityData[0].masterDataId,
                                                                        transferKey: user.transferKey,
                                                                        ...metaInfo
                                                                    };

                                                                    eloActivityPayload.push(eloActivityObject)


                                                                }

                                                                dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, homeworkNodeActivityInsertPayload).then((insertedHomeworkNodes) => {

                                                                    dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivityPayload).then((insertedHomeworkEloActivity) => {
                                                                        console.log('updated User Data')
                                                                    })
                                                                })
                                                            });
                                                        })

                                                    }
                                                    else {
                                                        // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "No Question Category found." }, res, req);
                                                        console.log('No Question Category found.')
                                                        alert('No Question Category found.')
                                                        return;
                                                    }
                                                });
                                            })
                                        })
                                    });
                                })
                            })
                        }
                        else {
                            console.log('homework node not found.')
                            alert('homework node not found.')
                            // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "homework node not found." }, res, req);
                            return;
                        }

                    })


                }
                else {
                    nodeActivities = [nodeActivities]
                    let nodeActivity = nodeActivities[0];
                    console.log(nodeActivity, 'resume flow.........')
                    this.resumeFlow(nodeActivity, metaInfo, contentsHash, assessmentQuestionType, callback);
                }

            })
        }).catch(err => {
            console.log(err)
        })
    }

    createNodeActivity(teacherUserId, node, homeworkId, metaInfo) {

        let nodeActivity = {
            userIdNodeIdHomeworkId: teacherUserId + node['_id'] + homeworkId,
            nodeId: node['_id'].toString(),
            userId: teacherUserId,
            homeworkId,
            primaryNode: node,
            totalAttempts: 1,
            status: "IN_PROGRESS",
            createdDate: new Date(),
            resume: {
                type: 'ASSESSMENT',
                eloId: node.elos[0].id,
                contentId: null,
                node: node,
                nodeType: 'NORMAL'
            },
            transferKey: "SCHOOL_TEACHER_TRANSFER_KEY",
            // ...Utils.getAcademicMetaInformation(req),
            ...metaInfo
        };

        return [nodeActivity];
    }

    prepareQueryForAssessmentContent(eloDetails) {
        let query = {}
        let contentIdList = eloDetails.objects.assessment.map((content) => content.contentId);

        if (eloDetails.objects.homeworkQuestions && eloDetails.objects.homeworkQuestions.length) {

            let noActiveQuestions = false

            let c1contentIdList = eloDetails.objects.homeworkQuestions.map((content) => {
                if (content.status) {
                    return content.contentId
                }
            });

            if (c1contentIdList.length) {
                contentIdList = [...contentIdList, ...c1contentIdList]
            }

        }

        return contentIdList;
    }

    prepareQueryForAssessmentMetadata(eloDetails) {
        let query = {}
        let contentIdList = eloDetails.objects.assessment.map((content) => content.metaDataId);
        if (eloDetails.objects.homeworkQuestions && eloDetails.objects.homeworkQuestions.length) {
            let noActiveQuestions = false
            let c1contentIdList = eloDetails.objects.homeworkQuestions.map((content) => {

                if (content.status) {
                    return content.metaDataId
                }

            })

            if (c1contentIdList.length) {
                contentIdList = [...contentIdList, ...c1contentIdList]
            }

        }
        return contentIdList;
    }


    groupByQuestionCategory(questions, questionsMetas, homeworkId) {

        let groupByCategoryQuestions = {};
        let metaHashAgainstQuestionId = {};

        questionsMetas.map((m) => {
            metaHashAgainstQuestionId[m.objectId] = m;
        });

        questions.map((q) => {

            let meta = metaHashAgainstQuestionId[q['_id']];
            if (meta.questionType === 'ADVANCED' && homeworkId === '671f3dc685c9a6272ae24787') {
                if (groupByCategoryQuestions[meta.questionCategory.title]) {
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
                else {
                    groupByCategoryQuestions[meta.questionCategory.title] = [];
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
            } else if (homeworkId != '671f3dc685c9a6272ae24787') {
                if (groupByCategoryQuestions[meta.questionCategory.title]) {
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
                else {
                    groupByCategoryQuestions[meta.questionCategory.title] = [];
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
            }
        });


        // let questionCategory = Object.keys(groupByCategoryQuestions)

        // if (questionCategory.includes('M1')) {
        //     questionCategory = ['M1']
        // }


        return groupByCategoryQuestions;
    }


    getAssessmentContentResponse(questions) {

        let response = {
            content: [
            ],

            contentType: "QUESTION"
        };

        response.content = questions.map((q) => {

            return {
                id: q["_id"],
                details: q,
                answer: null
            };
        })

        return response;
    }

    getEloPosition(nodeActivity, eloId) {

        let index = 0;
        let elos = nodeActivity.resume.node.elos;

        for (let i = 0; i < elos.length; i++) {

            if (elos[i].id == eloId) {
                index = i;
                break;
            }
        }

        let position = {
            eloPosition: index + 1,
            totalElos: nodeActivity.resume.node.elos.length
        }

        return position;
    }


    resumeFlow(nodeActivity, metaInfo, contentsHash, assessmentQuestionType, callback) {

        let eloIds = this.getAllElosTillElo(nodeActivity.resume.eloId, nodeActivity.resume.node.elos, true);

        let eloQuery = { _id: { $in: eloIds } };

        dbHelper.getData(Constants.ELO_STORE, eloIds[0]).then((eloDetails) => {

            console.log(eloDetails)

            eloDetails = [eloDetails]

            let videoContentUrl = ""

            // console.log(videoContentUrl)

            // let eloActivityQuery = getQueryPayloadForELOActivitiesOnResume(nodeActivity, false);

            let userIdNodeIdHomeworkId = nodeActivity.userId + nodeActivity.nodeId + nodeActivity.homeworkId


            dbHelper.getData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, userIdNodeIdHomeworkId).then((eloActivities) => {

                console.log(eloActivities)

                eloActivities = [eloActivities]

                if (eloActivities.length == 0) {
                    // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "No ELO activity found to resume." }, res, req);
                    callback({ message: "No ELO activity found to resume." }, null)
                    return;
                }

                let response = {
                    resume: {
                        contentId: nodeActivity.resume.contentId
                    },
                    content: []
                };

                this.getRightQuestionsForElosNew(nodeActivity.resume.eloId, eloDetails, eloActivities, videoContentUrl, metaInfo, contentsHash, assessmentQuestionType, (err, questionsResumeElo) => {

                    let resumeContents = []

                    if (metaInfo.selectSingleQuestionFromElo) {
                        response.content = questionsResumeElo.questions.slice(0, 1)
                    } else {
                        // response.content = questionsResumeElo.questions;
                        resumeContents = questionsResumeElo.questions;
                    }

                    let position = this.getEloPosition(nodeActivity, nodeActivity.resume.eloId);
                    let eloQuestions = questionsResumeElo.questions

                    response = {
                        ...response,
                        ...position
                    }

                    let homeworkAllEloActivityQuery = {
                        homeworkId: nodeActivity.homeworkId,
                        userId: nodeActivity.userId,
                        transferKey: nodeActivity.transferKey,
                        "attemptNumber": 1,
                        "type": "PRIMARY"
                    }

                    dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', nodeActivity.homeworkId).then((homeworkEloActivityData) => {

                        let homeworkAllEloActivityData = homeworkEloActivityData.filter(item => item.userId === nodeActivity.userId)

                        let completedQuestionNumber = 0, previousContentIds = [], previousEloIds = []

                        homeworkAllEloActivityData.forEach(activity => {
                            if (Object.keys(activity.answers).length) {

                                completedQuestionNumber += Object.keys(activity.answers).length
                                previousEloIds.push(activity.eloId)

                                Object.entries(activity.studentAnswers).forEach(([key, value]) => {
                                    previousContentIds.push(key)
                                })
                            }
                        })

                        dbHelper.getAllByIds(Constants.ELO_STORE, previousEloIds).then((previousEloDetails) => {

                            let previousEloHash = {}

                            if (previousEloDetails.length) {
                                previousEloDetails.map(elo => previousEloHash[elo._id.toString()] = elo)
                            }


                            dbHelper.getAllByIds(Constants.CONTENTS_STORE, previousContentIds).then((contentData) => {
                                let contentHash = {}, contents = []
                                let currentEloId = eloIds.map(elo => elo.toString())

                                let resumentContentsHash = {}

                                resumeContents.forEach(content => resumentContentsHash[content.id] = content)

                                if (contentData.length) {
                                    contentData.map(content => contentHash[content._id.toString()] = content)
                                    homeworkAllEloActivityData.forEach(activity => {
                                        if (Object.keys(activity.answers).length) {
                                            Object.entries(activity.studentAnswers).forEach(([key, value]) => {
                                                let q = contentHash[key]
                                                q.eloTitle = previousEloHash[activity.eloId].title
                                                // q.videoUrl = videoContentUrl
                                                let obj = {
                                                    eloId: previousEloHash[activity.eloId]["_id"].toString(),
                                                    categoryThemeId: previousEloHash[activity.eloId]["categoryThemeId"],
                                                    id: q["_id"],
                                                    details: q,
                                                    answer: value.answer,
                                                    optionsHash: value.optionsHash,
                                                    nodeId: activity.nodeId
                                                }

                                                if (!q.content.type && value.multiStepTimeListHash) {
                                                    obj.multiStepTimeListHash = value.multiStepTimeListHash ? value.multiStepTimeListHash : {}
                                                }

                                                if (!q.content.type && value.caseStudySkillHash) {
                                                    obj.caseStudySkillHash = value.caseStudySkillHash ? value.caseStudySkillHash : {}
                                                }
                                                contents.push(obj)
                                            })
                                        }
                                    })
                                }

                                if (contents.length) {
                                    resumeContents.forEach(content => {   // in a elo with 3 question if your in 2 question, then add the 3rd question
                                        if (!contentHash[content.id]) {
                                            contents.push(resumentContentsHash[content.id])
                                        }
                                    })
                                    response.content = contents
                                } else {
                                    response.content = resumeContents
                                }


                                response['completedQuestionNumber'] = completedQuestionNumber

                                if (response.resume.contentId == null) {
                                    response.resume.contentId = eloQuestions[0].id;
                                }
                                console.log(response)
                                callback(null, response)
                                // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);

                            });
                        });
                    });
                });
            });
        });
    }


    getAllElosTillElo(eloId, elos, isObjectId) {

        let _elos = [];
        let index = -1;
        for (let i = 0; i < elos.length; i++) {

            if (elos[i].id == eloId) {

                index = i;
                break;
            }
        }

        if (index != -1) {
            for (let i = 0; i <= index; i++) {
                if (isObjectId)
                    _elos.push(elos[i].id);
                else
                    _elos.push(elos[i].id)
            }
        }

        return _elos;
    }


    getRightQuestionsForElosNew(resumeEloId, eloDetails, eloActivities, videoContentUrl, metaInfo, contentsHash, assessmentQuestionType, callback) {

        let questionIds = [];
        let metaDataIds = [];

        let filterResumeEloDetails = eloDetails.filter((elo) => elo._id.toString() == resumeEloId);
        let filterResumeEloActivity = eloActivities.filter((elo) => elo.eloId == resumeEloId)

        let resumeEloDetails = filterResumeEloDetails[0];
        let resumeEloActivity = filterResumeEloActivity[0];

        // if (resumeEloDetails.objects.homeworkQuestions && resumeEloDetails.objects.homeworkQuestions.length) {
        //     resumeEloDetails.objects.homeworkQuestions.map((q) => {
        //         if (q.status) {
        //             questionIds.push(q.contentId);
        //             metaDataIds.push(q.metaDataId);
        //         }
        //     });
        // }

        resumeEloDetails.objects.assessment.map((q) => {
            questionIds.push(q.contentId);
            metaDataIds.push(q.metaDataId);
        });

        if (questionIds.length === 0 && metaDataIds.length === 0) {
            resumeEloDetails.objects.assessment.map((q) => {
                questionIds.push(q.contentId);
                metaDataIds.push(q.metaDataId);
            });
        }

        let query = {
            content: { _id: { $in: questionIds } },
            metadata: { _id: { $in: metaDataIds } }
        };

        dbHelper.getAllByIds(Constants.CONTENTS_STORE, questionIds).then((ContentData) => {

            dbHelper.getAllByIds(Constants.CONTENT_META_DATA_STORE, metaDataIds).then((metaDataContents) => {

                let mapAssessmentQuestions = {};

                let assessmentContents = {
                    contents: ContentData,
                    metadata: metaDataContents
                }

                console.log(assessmentContents)


                assessmentContents.contents.map((q) => {
                    mapAssessmentQuestions[q["_id"]] = {
                        content: q
                    };
                });

                assessmentContents.metadata.map((m) => {
                    let obj = mapAssessmentQuestions[m.objectId];
                    obj['meta'] = m;
                });


                let questionCategory = resumeEloActivity.questionCategory;

                let assessmentDetails = [];

                // if (resumeEloDetails.objects.homeworkQuestions && resumeEloDetails.objects.homeworkQuestions.length) {
                //     resumeEloDetails.objects.homeworkQuestions.map((ass) => {
                //         if (ass.status) {
                //             let content = mapAssessmentQuestions[ass.contentId].content;
                //             let meta = mapAssessmentQuestions[ass.contentId].meta;
                //             // To not show the Type 7 Labeling Questions
                //             if (content.content.type !== 7) {
                //                 assessmentDetails.push(content);
                //             }
                //         }

                //     });
                // }

                resumeEloDetails.objects.assessment.map((ass) => {
                    console.log(ass)

                    if (mapAssessmentQuestions[ass.contentId]) {
                        let content = mapAssessmentQuestions[ass.contentId].content;
                        let meta = mapAssessmentQuestions[ass.contentId].meta;
                        // To not show the Type 7 Labeling Questions // Show only Signle Select Questions from Worksheet masterdata
                        if (questionCategory == meta.questionCategory.title && (content.content.type === 1 || (content.content.isMultiStep && content.content.practice && content.content.practice.id === 'CASE STUDY'))) {

                            if (metaInfo.showTimer) {
                                if (content.content.competency && content.content.competency.id === 'YES') {
                                    if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                        content.content.duration = '1.5'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                        content.content.duration = '2'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                        content.content.duration = '2'
                                    }
                                } else if (metaInfo.showTimer) {
                                    if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                        content.content.duration = '1.5'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                        content.content.duration = '2'
                                    }
                                }
                            }

                            assessmentDetails.push(content);
                        }
                    }
                });


                if (!assessmentDetails.length) {
                    resumeEloDetails.objects.assessment.map((ass) => {

                        let content = mapAssessmentQuestions[ass.contentId].content;
                        let meta = mapAssessmentQuestions[ass.contentId].meta;
                        // To not show the Type 7 Labeling Questions // Show only Signle Selectr Questions from Worksheet masterdata
                        if (questionCategory == meta.questionCategory.title && (content.content.type === 1 || (content.content.isMultiStep && content.content.practice && content.content.practice.id === 'CASE STUDY'))) {
                            assessmentDetails.push(content);
                        }
                    });
                }

                // To Update the Image in offline

                assessmentDetails.forEach(contentItem => {
                    let content = contentItem.content
                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            delete item.imageUrl
                            item.imageUrl = URL.createObjectURL(item.imageBlob)
                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                delete option.content
                                option.content = URL.createObjectURL(option.imageBlob)
                            }
                        })
                    }


                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    delete item.imageUrl
                                    item.imageUrl = URL.createObjectURL(item.imageBlob)
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                        delete option.content
                                        option.content = URL.createObjectURL(option.imageBlob)
                                    }
                                })
                            }

                        })
                    }
                })

                if (assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS' && contentsHash) {
                    assessmentDetails = assessmentDetails.filter(item => contentsHash[item._id.toString()] === true)
                }


                let filteredQuestions = assessmentDetails.map((q) => {
                    q.eloTitle = eloDetails[0].title
                    q.videoUrl = videoContentUrl
                    let studentAnswers = resumeEloActivity.studentAnswers && resumeEloActivity.studentAnswers[q["_id"]] ? resumeEloActivity.studentAnswers[q["_id"]] : null
                    return {
                        eloId: resumeEloDetails["_id"].toString(),
                        categoryThemeId: resumeEloDetails["categoryThemeId"],
                        id: q["_id"],
                        details: q,
                        // answer: resumeEloActivity.answers[q["_id"]] ? resumeEloActivity.answers[q["_id"]] : null
                        answer: studentAnswers ? studentAnswers.answer : null,
                        optionsHash: studentAnswers ? studentAnswers.optionsHash : null
                    }
                });

                let questionsByElo = {
                    eloId: resumeEloDetails["_id"].toString(),
                    questions: filteredQuestions
                };

                console.log(questionsByElo)

                callback(null, questionsByElo);

            });
        }).catch(err => {
            console.log('getRightQuestionsForElosNew Error', err)
        })
    }

    onClickTestClicker(item) {

        if (CommonUtils.isOnline()) {
            this.setState({ showTestClickerScreen: true, selectedItem: item })
        } else if (!CommonUtils.isOnline()) {
            console.log('offline resume')

            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item._id).then(teacherHomeworkActivityData => {
                let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                let userIds = teacherHomeworkActivity.userIdsList
                // To Add Teacher UserId
                userIds.push(teacherHomeworkActivity.userId)


                dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                    clickerUserList = clickerUserList.sort((a, b) => a.studentNumber - b.studentNumber)

                    this.setState({ showTestClickerScreen: true, selectedItem: item, studentList: clickerUserList })

                })
            }).catch(err => {
                console.log(err)
            })


        }

    }

    hideTestClickerScreen() {
        this.setState({ showTestClickerScreen: false, selectedItem: '' })
    }

    hideStartPracticeScreen() {
        this.setState({ showStartPracticeScreen: false })
    }

    showStandardPracticeExperience(usersList) {
        // console.log(usersList)
        this.setState({ showStandardClassworkExperience: true, showStartPracticeScreen: false, usersList })
    }

    showRevisionExpereince(usersList, selectedSetOption) {
        this.setState({ usersList, showStartPracticeScreen: false, showRevisionFlow: true, selectedSetOption })
    }


    toggleFullScreenLoading = (value, callback) => {
        this.setState({ fullScreenLoading: value }, () => {
            callback && callback()
        })
    }

    hideStandardClassworkExperience() {
        this.setState({ showStandardClassworkExperience: false })
    }

    base64ToBlobUrl = (base64Data, contentType) => {
        // Decode base64 to binary
        const binaryData = atob(base64Data);
        const byteArray = new Uint8Array(binaryData.length);

        // Create an array of 8-bit unsigned integers to hold binary data
        for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
        }

        // Create Blob from byte array
        const blob = new Blob([byteArray], { type: contentType });
        // return URL.createObjectURL(blob);
        return blob;
    };


    onClickDownload(item, callback) {
        // console.log(item)
        // console.log(dbHelper)

        let payload = {}

        payload.isFromMyHomework = true
        payload.homeworkActivityId = item.teacherHomeworkActivityId

        payload.board = item.board
        payload.class = item.class
        payload.sectionId = item.sectionId

        HomeworkForClickerPracticeApi.downloadOfflineUserChapterHomework(payload).then(response => {
            // console.log(response)
            if (response.teacherHomeworkActivity.length &&
                response.contentsList.length &&
                response.clickerUserList.length &&
                response.homeworkNodeList.length &&
                response.eloList.length &&
                response.contentMetaDataList.length
            ) {
                item.isDownloaded = true
                item.schoolId = response.teacherHomeworkActivity[0].schoolId

                response.contentsList.forEach(contentItem => {
                    let content = contentItem.content
                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            const [contentType, base64Data] = item.base64Data.split(';base64,');
                            const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                            delete item.base64Data
                            item.imageBlob = imageBlob

                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                const [contentType, base64Data] = option.base64Data.split(';base64,');
                                const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                delete option.base64Data
                                option.imageBlob = imageBlob
                            }
                        })
                    }

                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    const [contentType, base64Data] = item.base64Data.split(';base64,');
                                    const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                    delete item.base64Data
                                    item.imageBlob = imageBlob
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                        const [contentType, base64Data] = option.base64Data.split(';base64,');
                                        const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                        delete option.base64Data
                                        option.imageBlob = imageBlob
                                    }
                                })
                            }

                        })
                    }

                    // For Summary Solution

                    if (content.solutionSteps.summarySolutionImagesMap) {
                        let imagesMap = content.solutionSteps.summarySolutionImagesMap
                        for (const imgId in imagesMap) {
                            const [contentType, base64Data] = imagesMap[imgId].split(';base64,');
                            const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                            imagesMap[imgId] = imageBlob
                        }
                        // console.log(imagesMap)
                        content.solutionSteps.summarySolutionImagesMap = imagesMap
                    }
                })



                item.chapter = { title: response.chapterTitle }

                let dataArray = [item]
                dbHelper.updateBulkData(Constants.HOMEWORK_STORE, dataArray).then(res => {

                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, response.teacherHomeworkActivity).then(res => {
                        // console.log(res)

                        dbHelper.updateBulkData(Constants.HOMEWORK_NODES_STORE, response.homeworkNodeList).then(nodeRes => {
                            // console.log(nodeRes)

                            dbHelper.updateBulkData(Constants.ELO_STORE, response.eloList).then(res => {

                                dbHelper.updateBulkData(Constants.CONTENTS_STORE, response.contentsList).then(contentRes => {
                                    // console.log(contentRes)

                                    dbHelper.updateBulkData(Constants.CONTENT_META_DATA_STORE, response.contentMetaDataList).then(res => {

                                        dbHelper.updateBulkData(Constants.CLICKER_USERS_STORE, response.clickerUserList).then(userListUpdatedRes => {
                                            // console.log(userListUpdatedRes)
                                            callback(null, true)
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }
            else {
                this.showToaster('error', `Due to Internet issue Assessment Not Downloaded`)
            }

        }).catch(err => {
            console.log(err)
            callback(err, false)
        })
    }


    updateItem = (id, homeworkItem, type) => {


        if (type === 'DOWNLOAD') {

            this.setState((prevState) => ({
                homeworkList: prevState.homeworkList.map((item) =>
                    item._id === id ? { ...item, isDownloading: true, isPresentInThisSystem: true } : item
                )
            }));

            this.onClickDownload(homeworkItem, (err, res) => {
                // console.log(res)
                if (res) {
                    this.showToaster('info', `Clicker Practice Downloaded Successfully`)
                    this.teacherHomeworkActivityStatusHash[homeworkItem._id]['isDownloaded'] = true
                    this.teacherHomeworkActivityStatusHash[homeworkItem._id]['isPresentInThisSystem'] = true

                    this.setState((prevState) => ({
                        homeworkList: prevState.homeworkList.map((item) =>
                            item._id === id ? { ...item, isDownloaded: true, isDownloading: false } : item
                        )
                    }));
                }
            })
        }

        if (type === 'SYNC') {

            if (!CommonUtils.isOnline()) return

            let teacherHomeworkActivityId = homeworkItem.teacherHomeworkActivityId

            dbHelper.getData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherHomeworkActivityId).then(teacherActivity => {
                console.log(teacherActivity)

                if (!teacherActivity.pendingSync) {
                    alert('Already Sync Completed')
                    return;
                }

                this.setState((prevState) => ({
                    homeworkList: prevState.homeworkList.map((item) =>
                        item._id === id ? { ...item, isDownloaded: true, pendingSync: true, isSynchronizing: true } : item
                    )
                }));

                this.onClickSync(homeworkItem, (err, res) => {
                    // console.log(res)
                    // homeworkItem.pendingSync = false
                    // console.log(homeworkItem)
                    // let dataArray = [homeworkItem]

                    // this.setState((prevState) => ({
                    //     content: prevState.content.map((item) =>
                    //         item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: true } : item
                    //     )
                    // }));





                    teacherActivity.pendingSync = false

                    teacherActivity = [teacherActivity]

                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivity).then(updateTeacherActivityRes => {
                        if (res) {
                            this.showToaster('info', `Synced Successfully`)
                            // this.setState((prevState) => ({
                            //     content: prevState.content.map((item) =>
                            //         item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: false } : item
                            //     )
                            // }));
                            this.teacherHomeworkActivityStatusHash[homeworkItem._id]['pendingSync'] = false
                            this.setState((prevState) => ({
                                homeworkList: prevState.homeworkList.map((item) =>
                                    item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: false } : item
                                )
                            }), () => {
                                this.getTeacherHomeworkActivities()
                            });
                        }
                    })
                }).catch(err => {
                    console.log(err)
                })

            }).catch(err => {
                console.log(err)
            })
        }
    };



    onClickSync(homeworkItem, callback) {
        console.log(homeworkItem)

        dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, 'homeworkId', homeworkItem._id).then(nodeActivity => {

            dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', homeworkItem._id).then(eloActivity => {

                dbHelper.getAllFromIndex(Constants.CLICKER_ASSESSMENT_LEADERBOARD, 'homeworkId', homeworkItem._id).then(clickerLeaderboard => {

                    dbHelper.getData(Constants.HOMEWORK_STORE, homeworkItem._id).then(homeworkData => {
                        dbHelper.getAllFromIndex(Constants.HOMEWORK_NODES_STORE, 'homeworkId', homeworkItem._id).then((homeworkNodes) => {

                            // console.log(clickerLeaderboard, eloActivity)

                            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkItem._id).then(teacherHomeworkActivity => {
                                let payload = {
                                    nodeActivity,
                                    eloActivity,
                                    clickerLeaderboard,
                                    teacherHomeworkActivity,
                                    homeworkId: homeworkItem._id,
                                    homeworkNodes,
                                    homeworkData
                                }
                                HomeworkApi.syncOfflineUserClickerPracticeActivity(payload).then(synCompletedRes => {
                                    callback(null, true)
                                })
                            })
                        })
                    })
                })
            })
        }).catch(err => {
            console.log(err)
            callback(err, false)
        })



    }

    showAssessmentEndScreen(assessmentCompletedInfo) {
        console.log(assessmentCompletedInfo)
        this.setState({ showStandardClassworkExperience: false, showAssessmentEndScreen: true, ...assessmentCompletedInfo })
    }

    hidePracticeEndScreen() {
        this.setState({ showAssessmentEndScreen: false }, () => {
            this.getTeacherHomeworkActivities()
            // this.toggleLayoutBar()


            if (!CommonUtils.isOnline() && navigator.onLine) {
                this.layoutShared.forceOffline(false)
            }
        })
    }

    showPracticeListScreen() {
        this.setState({ showStandardClassworkExperience: false }, () => {
            this.toggleLayoutBar()
            if (!CommonUtils.isOnline() && navigator.onLine) {
                this.layoutShared.forceOffline(false)
            } else {
                this.getTeacherHomeworkActivities()
            }

        })
    }

    logout = () => {

        this.setState({
            isLoading: true
        });

        let cookieItem = { hash: 'session', value: "" }
        dbHelper.updateData(Constants.COOKIE_STORE, cookieItem).then((id) => {
            Service.createData(Urls, {}, (err, res) => {
                SessionCache.setUser({
                    isAuthenticated: false
                });

                this.setState({
                    isLoading: false,
                });

                setTimeout(() => {
                    this.setState({
                        isLogout: true,
                    });
                }, 200);
            })
        }).catch(err => {
            console.log(err)
        })

        //  if (window.electron) {
        //     // console.log('zoom out called')
        //     window.electron.ipcRenderer.send('close-app', ['ping'])
        // }


    }

    showClickerAssessmentList() {
        this.setState({ showAssessmentFlow: false }, () => {
            this.toggleLayoutBar()
            // if (!CommonUtils.isOnline() && navigator.onLine) {
            //     this.layoutShared.forceOffline(false)
            // } else {
            this.getTeacherHomeworkActivities()
            // }
        })
    }





    render() {


        // console.log(CommonUtils.isOnline())

        if (this.state.showNewHomework && (this.state.boardsDropdownItems?.length !== 0 && this.state.classDropdownItems?.length !== 0)) {
            return <NewHomework
                type={this.state.type === Constants.CLICKER_CONCEPT_CARD ? Constants.CLICKER_CONCEPT_CARD : "CLICKER_PRACTICE_STANDARD"}
                delegate={this}
                isFromDraft={this.state.isDraft}
                assessmentQuestionType={this.state.isDraft ? this.state.assessmentQuestionType : ""}
                contentsHash={this.state.isDraft || this.state.isClonePractice ? this.state.contentsHash : {}}
                isFinishLine={this.state.isFinishLine}
                selectedHomework={this.state.selectedHomework}
                moreThanOneBoard={this.state.boardsDropdownItems?.length > 1 ? true : false}
                isClonePractice={this.state.isClonePractice ? true : false}
                title={this.state.type === Constants.CLICKER_CONCEPT_CARD ? 'New Revision' : 'Classroom Practice'} />
        }

        if (this.state.showNewHomework && (this.state.boardsDropdownItems?.length == 0 || this.state.classDropdownItems?.length == 0)) {
            return <Modal className="cw-custom-modal-center modal-md" isOpen={true} toggle={this.hideNewHomework} size={''}>
                <ModalBody >
                    <div className='d-flex flex-column'>
                        <div className='margin-left'>CLASS & SECTION NOT ASSIGNED</div>
                        <div className='sub-text'>Please request the admin to assign a Class & Section to
                            your profile in order to create a Homework</div>
                    </div>
                </ModalBody>
                <ModalFooter className='justify-content-center'>
                    <Button color="primary" onClick={this.hideNewHomework}>GOT IT</Button>{' '}
                    {/* <Button color="secondary" onClick={this.toggle}>Cancel</Button> */}
                </ModalFooter>
            </Modal>
        }

        if (this.state.showStartPracticeScreen) {
            return <StartAssessment
                meta={this.state.params}
                selectedSetOption={this.state.selectedSetOption}
                delegate={this}
                studentList={this.state.usersList}
            />
        }

        if (this.state.showStandardClassworkExperience && CommonUtils.isOnline()) {
            return (
                <StandardClassWorkExperience
                    params={this.state.params}
                    delegate={this}
                    studentList={this.state.usersList}
                />
            )
        } else if (this.state.showStandardClassworkExperience && !CommonUtils.isOnline()) {
            return (<StandardClassworkExperienceOffline
                params={this.state.params}
                delegate={this}
                studentList={this.state.usersList}
            />)
        }

        if (this.state.showAssessmentEndScreen) {
            return (
                <ClickerAssessmentEndScreen metaInfo={this.state} delegate={this} studentList={this.state.usersList} />
            )
        }

        if (this.state.showQuestionLeaderBoard) {
            return <Leaderboard
                delegate={this}
                totalQuestions={this.state.selectedItem.approximateQuestions}
                questions={this.props.questions}
                // quote={this.props.isMultiStep ? this.props.mulipStepQuestion.content.quote : content.content.quote}
                activePage={this.state.selectedItem.approximateQuestions}
                isFullScreenMode={true}
                showStudentResponse={this.state.showStudentResponse}
                showLeaderboard={true}
                leaderboardLimit={this.props.leaderboardLimit}
                chapterTitle={this.props.chapterTitle}
                showLargeStudentResponseSideBar={true}
                timeListHash={this.state.timeListHash}
                showQuestionLeaderBoard={true}
                leaderboardData={this.state.leaderboardData}
                studentListHash={this.state.studentListHash}
                showBackButton={true}
            />
        }

        // if (this.state.showBarChart) {
        //     return <BarChart />
        // }


        if (this.state.showReport) {
            return this.renderReport()
        }

        if (this.state.showTestClickerScreen && CommonUtils.isOnline()) {
            return <ClickerTesting delegate={this} selectedItem={this.state.selectedItem} />
        } else if (this.state.showTestClickerScreen && !CommonUtils.isOnline()) {
            return <ClickerTesting delegate={this}
                selectedItem={this.state.selectedItem} studentList={this.state.studentList} />
        }


        if (this.state.showUsersList) {
            return <StudentNameList delegate={this} selectedItem={this.state.selectedItem} />
        }

        if (this.state.showRevisionFlow) {
            return <ClickerRevisionExperience studentList={this.state.usersList} conceptCardPdf={this.state.selectedItem?.conceptCardPdf} delegate={this} />
        }

        if (this.state.showAssessmentFlow) {
            return <JigyasaAssessment meta={this.state.teacherHomeworkItem} delegate={this} selectedSetOption={this.state.selectedSetOption} />
        }

        if (this.state.showTestResultReport)
            return <TestResultReport selectedItem={this.state.selectedItem} delegate={this} />


        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}

                {this.state.isLogout && <Redirect to={Path.LOGIN} />}

                <div className='clicker-flow-practice-list-screen-new mt-5'>

                    <div>
                        {this.state.showBackButton || Constants.ELECTRON_BUILD ? <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> : ''}
                        <div className='d-flex justify-content-end'>
                            {/* {this.state.showBackButton ? <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> : ''} */}

                            {
                                this.checkCreateCondtion() ?

                                    <button style={{ marginTop: "-3.5rem" }} className=' cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickNewHomeWork()}>
                                        {this.state.type === Constants.CLICKER_CONCEPT_CARD ? 'New Revision' : 'New Practice'}
                                    </button>

                                    : ""
                            }
                            {/* {
                                <div className="close-icon-wrapper  cursor-pointer" onClick={() => this.logout()}>
                                    <img className="close-icon" src={getImageSource(ImageConstants.CROSS)} />
                                </div>
                            } */}

                        </div>
                    </div>





                    {/* <div className='screen-title mt-3'>Clicker Practice List</div> */}

                    {
                        CommonUtils.isOnline() ?
                            <div className='margin-for-filter'>
                                <div className='mt-5'>
                                    <Filter delegate={this} />

                                    {/* <img className='seperator' src={getImageSource(ImageConstants.FILTER_SEPERATOR)} /> */}
                                </div>
                                {this.renderFilters()}
                            </div>
                            :
                            <>
                            </>
                    }


                    {this.renderList()}

                    <div className='card-footer'>
                        {
                            this.state.meta.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                        }
                    </div>

                    {/* {this.state.showStudentLevelReport && <StudentLevelReport show={this.state.showStudentLevelReport} delegate={this} close={this.hideStudentLevelReport} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />} */}
                    {/* {this.state.showReminderModal ? this.renderReminderModal() : ""} */}
                    {/* {this.state.showArchiveModal && <ArchiveModal title={`Are you sure you want to Archive this ${this.state.selectedHomework.type === 'STANDARD' || this.state.selectedHomework.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'}?`} delegate={this} onOk={this.onOkArchiveModal} onClose={this.onCloseArchiveModal} selectedItem={this.state.selectedHomework} />} */}
                    {/* {this.state.showActiveConfirmationModal && <ActiveHomeworkModal title={`Are you sure you want to Mark this ${this.state.selectedHomework.type === 'STANDARD' || this.state.selectedHomework.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} Active ?`} delegate={this} onOk={this.onOkActiveModal} onClose={this.onCloseActiveModal} selectedItem={this.state.selectedHomework} />} */}
                    {this.state.showDeletionModal && <AssignmentDeletionComponent title={`Are you sure you want to Delete this Clicker Practice`} delegate={this} onOk={this.onOkDeleteModal} onClose={this.onCloseDeleteModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showClickerAssignModal && <AssignmentDeletionComponent title={`Are you sure you want to Clone this Clicker Practice`} isAssignPractice={true} delegate={this} onOk={this.onOkClickerAssignModal} onClose={this.onCloseClickerAssignModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showMoreInfo ? this.showEloDetail() : ""}
                    {/* {this.state.showNotification ? this.renderNotificationModal() : ""} */}
                    {this.state.showSuccess ? <SuccessComponent
                        type={this.state.selectedItem.type}
                        title={`${this.state.selectedItem.type === 'STANDARD' || this.state.selectedItem.type === 'ADAPTIVE' ? 'HOMEWORK' : 'CLASSWORK'}  CREATED and SHARED WITH STUDENTS`}
                        subTitle={`Do You want to invite more students to take this ${this.state.selectedItem.type === 'STANDARD' || this.state.selectedItem.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'}?`}
                        students={this.state?.selectedItem?.totalUsers || 0}
                        close={this.closeSuccess}
                        onOk={this.onInviteMoreStudent}
                        class={this.state?.selectedItem?.class}
                        section={this.state?.selectedItem?.section ? Object.values(this.state?.selectedItem?.section).join(',') : ''}
                    /> : ""}
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }
                    {this.state.isDownloading && (
                        <Modal className="cw-custom-modal" isOpen={this.state.isDownloading} size={'md'}>
                            <ModalBody >
                                <div className="add-admin">
                                    <div className="header-text text-center">
                                        <span>{`Downloading Report...`}</span>
                                    </div>
                                    <div className='row px-5 py-5 margin-auto'>
                                        <img
                                            className='loader-icn'
                                            src={getImageSource(
                                                ImageConstants.PRE_LOADER_GIF
                                            )}
                                        />
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal >
                    )}
                </div >
                <ReactTooltip

                    ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='dark'
                    effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>);
    }
}

export default HomeworkList;